
(function(){
'use strict';
const $=(s,r)=>(r||document).querySelector(s);
const $$=(s,r)=>Array.from((r||document).querySelectorAll(s));
const sleep=ms=>new Promise(r=>setTimeout(r,ms));
const reduced=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
const mqMobile=matchMedia('(max-width: 860px)');
const mqNarrow=matchMedia('(max-width: 1100px)');
const store={
  get(k,d){try{const v=localStorage.getItem(k);return v==null?d:JSON.parse(v);}catch(e){return d;}},
  set(k,v){try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}}
};

/* ---------- Icons ---------- */
const ICONS={
  plus:'<path d="M12 5v14M5 12h14"/>',
  search:'<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
  sidebar:'<rect x="3" y="4" width="18" height="16" rx="3"/><path d="M9 4v16"/>',
  'panel-right':'<rect x="3" y="4" width="18" height="16" rx="3"/><path d="M15 4v16"/>',
  sun:'<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
  moon:'<path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z"/>',
  share:'<path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M16 6l-4-4-4 4M12 2v13"/>',
  'arrow-up':'<path d="M12 19V5M5 12l7-7 7 7"/>',
  stop:'<rect x="7" y="7" width="10" height="10" rx="2" fill="currentColor" stroke="none"/>',
  paperclip:'<path d="m21 11-8.6 8.6a5 5 0 0 1-7.1-7.1l8.6-8.6a3.3 3.3 0 0 1 4.7 4.7l-8.6 8.6a1.7 1.7 0 0 1-2.4-2.4l7.9-7.9"/>',
  mic:'<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/>',
  'chevron-down':'<path d="m6 9 6 6 6-6"/>',
  check:'<path d="M20 6 9 17l-5-5"/>',
  copy:'<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/>',
  refresh:'<path d="M21 12a9 9 0 1 1-2.6-6.4M21 3v6h-6"/>',
  'thumbs-up':'<path d="M7 10v11M15 5.9 14 10h5.8a2 2 0 0 1 2 2.3l-1.4 7A2 2 0 0 1 18.4 21H7V10l4-8a3 3 0 0 1 4 3.9z"/>',
  'thumbs-down':'<path d="M17 14V3M9 18.1l1-4.1H4.2a2 2 0 0 1-2-2.3l1.4-7A2 2 0 0 1 5.6 3H17v11l-4 8a3 3 0 0 1-4-3.9z"/>',
  compass:'<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5-5 2 2-5z"/>',
  pen:'<path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>',
  target:'<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>',
  chart:'<path d="M3 3v18h18"/><path d="m7 15 4-4 3 3 5-6"/>',
  funnel:'<path d="M3 4h18l-7 8v6l-4 2v-8z"/>',
  calendar:'<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/>',
  megaphone:'<path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1zM15 8a5 5 0 0 1 0 8M18 5a9 9 0 0 1 0 14"/>',
  users:'<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8"/>',
  x:'<path d="M18 6 6 18M6 6l12 12"/>',
  'corner':'<path d="M9 10 4 15l5 5"/><path d="M20 4v7a4 4 0 0 1-4 4H4"/>',
  trending:'<path d="m22 7-8.5 8.5-5-5L2 17"/><path d="M16 7h6v6"/>',
  more:'<circle cx="5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/>',
  zap:'<path d="M13 2 3 14h9l-1 8 10-12h-9z"/>',
  globe:'<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/>',
  layers:'<path d="m12 2 10 5-10 5L2 7z"/><path d="m2 17 10 5 10-5M2 12l10 5 10-5"/>',
  heart:'<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z"/>',
  file:'<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/>',
  road:'<circle cx="6" cy="6" r="3"/><circle cx="18" cy="18" r="3"/><path d="M9 6h6a3 3 0 0 1 0 6H9a3 3 0 0 0 0 6h6"/>',
  pie:'<path d="M21 12A9 9 0 1 1 12 3v9z"/><path d="M15 3.5A9 9 0 0 1 20.5 9H15z"/>'
};
function ic(n,s){s=s||16;return '<svg class="ic" width="'+s+'" height="'+s+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+(ICONS[n]||'')+'</svg>';}
const MARK_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="#E9F26A" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M4.5 18.5c4.6 0 6.8-2.6 8.2-6.4 1.3-3.6 3.2-5.6 6.3-5.6"/><circle cx="19" cy="6.5" r="2" fill="#E9F26A" stroke="none"/></svg>';

function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}

/* ---------- Data ---------- */
const PLATFORMS=[
  {id:'all',name:'All channels',mono:'All',c:'#2E43F0'},
  {id:'ig',name:'Instagram',mono:'Ig',c:'#E1306C'},
  {id:'tt',name:'TikTok',mono:'Tk',c:'#0FA3B1'},
  {id:'fb',name:'Facebook',mono:'Fb',c:'#1877F2'},
  {id:'meta',name:'Meta Ads',mono:'Ma',c:'#3B5BFF'},
  {id:'gads',name:'Google Ads',mono:'Ga',c:'#D99800'},
  {id:'li',name:'LinkedIn',mono:'Li',c:'#0A66C2'},
  {id:'yt',name:'YouTube',mono:'Yt',c:'#E8303F'},
  {id:'ms',name:'Microsoft Ads',mono:'Ms',c:'#0EA5E9'},
  {id:'em',name:'Email',mono:'Em',c:'#1F8A5B'},
  {id:'seo',name:'SEO',mono:'Se',c:'#7C5CFF'}
];
const HEADLINES={
  all:'What are we growing today?',ig:'What are we posting on Instagram?',tt:'What is the next TikTok idea?',fb:'What are we running on Facebook?',
  meta:'Which Meta campaign are we building?',gads:'What should Google Ads do for you?',li:'Who are we reaching on LinkedIn?',
  yt:'What is the next YouTube video?',ms:'Where does Microsoft Ads fit in?',em:'What goes in the next email?',seo:'What should we rank for next?'
};
const GOALS=[
  {id:'awareness',name:'Awareness',desc:'Reach, recall and brand lift',icon:'globe'},
  {id:'engagement',name:'Engagement',desc:'Followers, saves and shares',icon:'heart'},
  {id:'leads',name:'Leads',desc:'Sign-ups, demos and enquiries',icon:'funnel'},
  {id:'sales',name:'Sales',desc:'Purchases and revenue',icon:'trending'},
  {id:'retention',name:'Retention',desc:'Repeat orders and lifetime value',icon:'refresh'}
];
const MODES=[
  {id:'strategist',name:'Strategist',desc:'Plans, positioning and growth strategy',icon:'compass',ph:'Ask about strategy, positioning or growth'},
  {id:'copywriter',name:'Copywriter',desc:'Ads, hooks, captions and emails',icon:'pen',ph:'Ask for ads, hooks, captions or emails'},
  {id:'media',name:'Media buyer',desc:'Campaigns, targeting and budgets',icon:'target',ph:'Ask about campaigns, targeting or budgets'},
  {id:'analyst',name:'Growth analyst',desc:'Metrics, diagnostics and testing',icon:'chart',ph:'Ask about ROAS, CTR, tests or reporting'}
];
const COMMANDS=[
  {cmd:'/ad-copy',label:'Ad copy brief',hint:'Business + audience + offer + proof',icon:'megaphone',brief:'ad_copy'},
  {cmd:'/hooks',label:'Hook generator brief',hint:'Product + audience + benefit',icon:'zap',brief:'hooks'},
  {cmd:'/calendar',label:'Content calendar brief',hint:'7 days with channel + goal',icon:'calendar',brief:'content_calendar'},
  {cmd:'/funnel',label:'Lead funnel brief',hint:'Offer + traffic + nurture',icon:'funnel',brief:'lead_funnel'},
  {cmd:'/audit',label:'Performance audit brief',hint:'Before/after metrics',icon:'chart',brief:'performance_audit'},
  {cmd:'/budget',label:'Budget allocation brief',hint:'Economics + channels + goal',icon:'pie',brief:'budget_plan'},
  {cmd:'/plan',label:'90-day growth brief',hint:'Baseline + target + budget',icon:'road',brief:'growth_90'},
  {cmd:'/persona',label:'Customer persona brief',hint:'Customers + pains + objections',icon:'users',brief:'persona'}
];
const STUDIOS=[
  {name:'Ad copy lab',icon:'megaphone',brief:'ad_copy'},
  {name:'Content studio',icon:'calendar',brief:'content_calendar'},
  {name:'Funnel builder',icon:'funnel',brief:'lead_funnel'},
  {name:'Performance doctor',icon:'chart',brief:'performance_audit'},
  {name:'Growth planner',icon:'road',brief:'growth_90'}
];
const SUGGEST=[
  {id:'meta_ads',p:'meta',goal:'sales',tag:'Arcline builds it · Meta Ads',text:'Create my Meta Ads campaign'},
  {id:'tiktok_week',p:'tt',goal:'engagement',tag:'Arcline builds it · TikTok',text:'Plan my TikTok content'},
  {id:'lead_funnel',p:'em',goal:'leads',tag:'Arcline builds it · Lead generation',text:'Build my lead funnel'},
  {id:'reels',p:'ig',goal:'engagement',tag:'Arcline builds it · Instagram',text:'Create my Instagram Reels plan'},
  {id:'growth_90',p:'all',goal:'sales',tag:'Arcline builds it · Strategy',text:'Build my 90-day marketing plan'},
  {id:'positioning',p:'all',goal:'awareness',tag:'Arcline builds it · Positioning',text:'Improve my brand positioning'},
  {id:'performance_audit',p:'meta',goal:'sales',tag:'Advanced · Performance data required',text:'Diagnose my ad performance'},
  {id:'linkedin_b2b',p:'li',goal:'leads',tag:'Arcline builds it · LinkedIn B2B',text:'Build my LinkedIn demand-gen campaign'},
  {id:'google_audit',p:'gads',goal:'sales',tag:'Advanced · Account data required',text:'Audit my Google Ads'},
  {id:'youtube_story',p:'yt',goal:'engagement',tag:'Arcline builds it · YouTube',text:'Turn a customer story into video content'}
];
const FOCUS=['all','ig','tt','meta','gads','li','yt','em','seo'];
const VOICES=['Warm','Expert','Bold','Playful'];
const WORDS_OK=['Arcline'];

function plat(id){return PLATFORMS.find(p=>p.id===id)||PLATFORMS[0];}
function goalOf(id){return GOALS.find(g=>g.id===id)||GOALS[3];}
function modeOf(id){return MODES.find(m=>m.id===id)||MODES[0];}
function monoChip(id){const P=plat(id);return '<span class="mono" style="--c:'+P.c+'">'+P.mono+'</span>';}
function chipRaw(mono,c){return '<span class="mono" style="--c:'+c+'">'+mono+'</span>';}
function parseBudget(s){return parseInt(String(s||'').replace(/[^\d]/g,''),10)||6000;}
function briefField(v,label){
  const value=String(v||'').trim();
  return value&&value!=='My Brand'?value:'['+label+']';
}
function briefBudget(){
  return String(state.brand.budget||'').trim()?'$'+parseBudget(state.brand.budget).toLocaleString('en-US')+' / month':'[Monthly marketing budget]';
}
function briefBase(){
  const B=state.brand||{};
  return {
    name:briefField(B.name,'Business / brand name'),
    offer:briefField(B.offer,'What do you sell? Include product/service and price if relevant'),
    audience:briefField(B.audience,'Target customer / ICP'),
    url:briefField(B.url,'Website or landing page'),
    market:briefField(B.market,'Primary country / market'),
    budget:briefBudget(),
    voice:B.voice||'Expert'
  };
}
function guidedBrief(id){
  const B=briefBase(),platform=state.platform!=='all'?plat(state.platform).name:'[Primary channel]';
  const common=[
    'Business / brand: '+B.name,
    'What we sell: '+B.offer,
    'Website: '+B.url,
    'Target audience: '+B.audience,
    'Primary market: '+B.market,
    'Brand voice: '+B.voice
  ];
  const templates={
    meta_ads:[
      'Create 3 distinct Meta ad angles for this campaign.','',...common,
      'Campaign goal: Sales',
      'Offer / promotion: [Exact offer, discount, bundle or reason to buy now]',
      'Campaign timing: [Launch date, season or evergreen]',
      'Monthly marketing budget: '+B.budget,
      'Proof I can legally use: [Reviews, results, credentials, guarantees or "none"]',
      'Creative assets available: [Product photos, UGC, founder video, demo, etc.]','',
      'Deliver: 3 genuinely different strategic angles. For each give the hook, primary text, headline, CTA, creative concept, why it should resonate, and the first variable to test. Do not invent testimonials, claims or performance.'
    ],
    tiktok_week:[
      'Build a 7-day TikTok content plan for this business.','',...common,
      'Primary product / service to feature: [Specific product or service]',
      'Content goal: [Awareness / engagement / leads / sales]',
      'Key benefit or transformation: [Main customer outcome]',
      'Proof / demonstrations available: [What can we show on camera?]',
      'Creator style available: [Founder / UGC creator / hands-only / AI / product-only]',
      'CTA: [What should viewers do next?]','',
      'Deliver: one post per day with concept, first-2-second hook, shot sequence, on-screen text, caption, CTA and what we are testing.'
    ],
    performance_audit:[
      'Diagnose this paid-media performance change before recommending fixes.','',...common,
      'Platform / campaign type: '+platform,
      'Before period: [Dates]','After period: [Dates]',
      'Budget / spend before → after: [Numbers]','CPM before → after: [Numbers or unknown]',
      'CTR before → after: [Numbers or unknown]','CPC before → after: [Numbers or unknown]',
      'Conversion rate before → after: [Numbers or unknown]','CPA / CAC before → after: [Numbers or unknown]',
      'AOV / lead value before → after: [Numbers or unknown]','ROAS / revenue before → after: [Numbers or unknown]',
      'What changed at the same time: [Budget, bid strategy, creative, audience, offer, site, tracking, seasonality]',
      'Attribution / tracking changes: [Any changes or none]','',
      'First isolate the likely bottleneck from the evidence. Separate facts from hypotheses. Then give checks in priority order and only then recommend actions.'
    ],
    lead_funnel:[
      'Design a lead-generation funnel for this business.','',...common,
      'Lead-generation offer: [Demo, consultation, quote, guide, quiz, trial, etc.]',
      'Traffic source: [Meta / Google / LinkedIn / organic / other]',
      'Lead magnet or quiz idea: [Existing idea or "create one"]',
      'Current email / CRM tool: [Klaviyo, HubSpot, Mailchimp, etc.]',
      'Lead quality definition: [What makes a good lead?]',
      'Sales step after nurture: [Call, checkout, demo, quote, etc.]',
      'Monthly marketing budget: '+B.budget,'',
      'Deliver: funnel stages, landing-page structure, form/quiz questions, lead-routing logic, 5-email welcome/nurture sequence, KPIs and the first experiment.'
    ],
    reels:[
      'Create Instagram Reels hooks and captions for a real product/service demo.','',...common,
      'Product / service being demonstrated: [Specific item]','Top 3 benefits: [Benefits]',
      'Biggest customer objection: [Objection]','Proof available: [Review, before/after, demo, certification, result or none]',
      'Offer / CTA: [Offer and desired action]','Visual assets available: [What footage can be used?]','',
      'Deliver: 10 hooks ranked by strength, 5 Reel concepts, shot-by-shot opening for the top 3, captions and CTAs. Do not invent proof.'
    ],
    growth_90:[
      'Build a practical 90-day growth plan for this business.','',...common,
      'Current monthly revenue / leads: [Baseline or "not available"]',
      '90-day business target: [Revenue, leads, customers, pipeline, etc.]',
      'Monthly marketing budget: '+B.budget,
      'Current active channels: '+(connectedChannelNames().length?connectedChannelNames().join(', '):'[Current channels, if any]'),
      'Current baseline metrics: [Traffic, CVR, CAC/CPA, AOV/LTV, ROAS or what is available]',
      'Strongest existing asset: [Audience, email list, organic traffic, product, content, partnerships, etc.]',
      'Main constraint: [Budget, creative, traffic, conversion, team, inventory, tracking, etc.]','',
      'Deliver: diagnosis, priorities, 30/60/90-day phases, channel role, budget allocation logic, weekly experiments, KPIs, decision rules and what NOT to do yet.'
    ],
    linkedin_b2b:[
      'Build a LinkedIn demand-generation campaign for this B2B offer.','',...common,
      'Buyer roles / job titles: [Primary buyers]','Company size / industry: [ICP firmographics]',
      'Pain we solve: [Business problem]','Offer / conversion: [Demo, audit, consultation, report, webinar, etc.]',
      'Proof available: [Customers, case studies, credentials or none]','Sales cycle / deal value: [If known]',
      'Monthly marketing budget: '+B.budget,'',
      'Deliver: audience structure, 3 messaging angles, ad concepts, landing-page promise, lead-quality criteria, retargeting sequence and pipeline KPIs.'
    ],
    positioning:[
      'Create a competitive positioning strategy for this brand.','',...common,
      'Main competitor: [Name + website if possible]','Why customers currently choose them: [Known reason or assumption]',
      'Our strongest differentiator: [What is meaningfully different]','Price position: [Cheaper / similar / premium / unknown]',
      'Proof we can support: [Evidence]','Customer objection we must overcome: [Objection]','',
      'Deliver: positioning statement, category/frame, 3 defensible differentiators, message hierarchy, proof gaps, comparison-page outline and claims we should avoid.'
    ],
    google_audit:[
      'Audit rising Google Ads costs using the actual before/after numbers.','',...common,
      'Campaign type: [Search / PMax / Shopping / YouTube / other]','Before period: [Dates]','After period: [Dates]',
      'Spend before → after: [Numbers]','Impressions / CPM before → after: [Numbers or unknown]',
      'CTR before → after: [Numbers]','Avg CPC before → after: [Numbers]',
      'Conversion rate before → after: [Numbers]','CPA before → after: [Numbers]',
      'Conversion value / AOV / ROAS before → after: [Numbers]','Bid strategy / target changes: [What changed]',
      'Search-term / product-mix changes: [What changed or unknown]','Tracking changes: [Any changes or none]','',
      'Diagnose the likely cause first, state what evidence would confirm it, then give the smallest set of changes to test.'
    ],
    youtube_story:[
      'Turn one real customer story into a 7-day YouTube/Shorts content sequence.','',...common,
      'Customer story: [What happened, using only verified facts]','Permission / proof available: [What may be publicly used]',
      'Product / service involved: [Specific offer]','Audience problem: [Pain or aspiration]',
      'Primary goal: [Awareness / subscribers / leads / sales]','CTA: [Next action]',
      'Footage available: [Interview, B-roll, product footage, screenshots, AI visuals, etc.]','',
      'Deliver: one anchor story, 5 Shorts concepts, hooks, story beats, title ideas, thumbnail concepts, CTA and repurposing plan. Do not invent customer details.'
    ],
    ad_copy:[
      'Create conversion-focused ad copy from this brief.','',...common,
      'Platform: '+platform,'Campaign goal: '+goalOf(state.goal).name,
      'Offer / CTA: [Exact offer and next action]','Key benefit: [Main customer outcome]',
      'Proof available: [Evidence or none]','Main objection: [Why might they not buy?]','',
      'Deliver: 3 strategic angles with primary copy, headline, CTA and creative direction. Do not invent proof.'
    ],
    hooks:[
      'Generate scroll-stopping hooks from this brief.','',...common,
      'Platform: '+platform,'Specific product / topic: [What is the content about?]',
      'Main benefit / tension: [Outcome, pain or curiosity]','Proof / demonstration: [What can be shown?]',
      'CTA: [Desired action]','',
      'Deliver: 20 hooks grouped by strategic angle, rank the top 5, and explain what makes those five stronger.'
    ],
    content_calendar:[
      'Build a 7-day content calendar from this brief.','',...common,
      'Primary channel: '+platform,'Business goal this week: [Awareness / engagement / leads / sales]',
      'Product / campaign focus: [Specific focus]','Content assets available: [Founder, UGC, product shots, graphics, customer stories, etc.]',
      'CTA: [Desired action]','',
      'Deliver: 7 days with format, topic, hook, key points, CTA and what each post is meant to test.'
    ],
    budget_plan:[
      'Allocate a monthly marketing budget based on business economics, not arbitrary percentages.','',...common,
      'Monthly budget: '+B.budget,'Primary business goal: '+goalOf(state.goal).name,
      'Current channels: '+(connectedChannelNames().length?connectedChannelNames().join(', '):'[Current channels]'),
      'Gross / contribution margin: [Percentage or unknown]','AOV / lead value: [Value or unknown]',
      'Current CAC / CPA: [Number or unknown]','Current ROAS / close rate: [Number or unknown]',
      'Minimum acceptable return / payback: [Target or unknown]','',
      'Deliver: allocation logic, recommended test budget by channel, measurement plan, scale/kill thresholds and what data is still required.'
    ],
    persona:[
      'Build evidence-aware customer personas for this business.','',...common,
      'Existing customer patterns: [What you already know]','Price / purchase frequency: [If known]',
      'Top customer pains: [Known pains]','Top objections: [Known objections]',
      'Alternatives they use today: [Competitors or workarounds]','',
      'Deliver: 3 practical buying personas with jobs-to-be-done, triggers, objections, proof needs, message angles, channels and research questions. Clearly label assumptions.'
    ]
  };
  return (templates[id]||templates.growth_90).join('\\n');
}

const BRIEF_FORMS={
  meta_ads:{kicker:'Meta Ads',title:'Build a Meta Ads campaign brief',sub:'Give Arcline the campaign facts once. It will turn them into angles, copy and test ideas.',display:'Meta Ads campaign brief',task:'Create 3 distinct Meta ad angles and a practical test plan.',fields:[
    {k:'focus',l:'Product / service to promote',p:'What exactly are we advertising?',r:1},
    {k:'offer',l:'Offer / promotion',p:'Price, discount, bundle, free trial, etc.',r:1},
    {k:'timing',l:'Campaign timing',p:'Evergreen, launch date, season, event'},
    {k:'proof',l:'Proof we may use',p:'Reviews, results, credentials, guarantee — or none',wide:1},
    {k:'assets',l:'Creative assets available',p:'Product photos, UGC, demo, founder video, etc.',wide:1}
  ]},
  tiktok_week:{kicker:'TikTok',title:'Build a 7-day TikTok plan',sub:'Add the product focus and the creative ingredients you actually have.',display:'7-day TikTok content brief',task:'Build a 7-day TikTok content plan with hooks, shot ideas, captions, CTAs and a clear testing objective.',fields:[
    {k:'focus',l:'Product / service to feature',p:'Specific product, service or campaign',r:1},
    {k:'outcome',l:'Main customer benefit',p:'What outcome or transformation matters most?',r:1},
    {k:'proof',l:'What can we demonstrate?',p:'Demo, result, process, comparison, before/after',wide:1},
    {k:'creator',l:'Creator style available',p:'Founder, UGC, hands-only, AI, product-only'},
    {k:'cta',l:'Desired CTA',p:'Shop, follow, comment, book, download, etc.'}
  ]},
  performance_audit:{kicker:'Performance',title:'Diagnose a performance drop',sub:'Paste the numbers you have. Unknown is fine — Arcline will separate facts from hypotheses.',display:'Paid-media performance audit',task:'Diagnose the performance change before recommending fixes.',fields:[
    {k:'campaign',l:'Platform / campaign',p:'e.g. Meta Sales, Google Search, PMax',r:1},
    {k:'period',l:'Comparison period',p:'e.g. Aug 1–14 vs Aug 15–28'},
    {k:'metrics',l:'Before → after metrics',p:'Spend, CPM, CTR, CPC, CVR, CPA/CAC, AOV, ROAS, revenue — include whatever you have.',wide:1,area:1,r:1},
    {k:'changes',l:'What changed at the same time?',p:'Budget, bidding, creative, audience, offer, website, seasonality',wide:1,area:1},
    {k:'tracking',l:'Tracking / attribution changes',p:'Any pixel, GA4, attribution-window or checkout changes?'}
  ]},
  lead_funnel:{kicker:'Lead generation',title:'Design a lead funnel',sub:'Define the offer and what a good lead looks like so the funnel is commercially useful.',display:'Lead-generation funnel brief',task:'Design a complete lead-generation funnel from traffic to follow-up and sales handoff.',fields:[
    {k:'lead_offer',l:'Lead-generation offer',p:'Demo, quote, consultation, guide, quiz, trial',r:1},
    {k:'traffic',l:'Primary traffic source',p:'Meta, Google, LinkedIn, organic, partnerships'},
    {k:'magnet',l:'Lead magnet / quiz idea',p:'Existing idea or ask Arcline to create one',wide:1},
    {k:'crm',l:'Email / CRM tool',p:'Klaviyo, HubSpot, Mailchimp, etc.'},
    {k:'quality',l:'What makes a qualified lead?',p:'Role, need, budget, intent, geography',wide:1},
    {k:'next',l:'Sales step after nurture',p:'Call, demo, checkout, quote, application'}
  ]},
  reels:{kicker:'Instagram Reels',title:'Create Reels from real product benefits',sub:'Give Arcline the proof and objection so the hooks are specific instead of generic.',display:'Instagram Reels brief',task:'Create ranked Reels hooks, concepts, captions and CTAs.',fields:[
    {k:'focus',l:'Product / service to demonstrate',p:'Specific item or service',r:1},
    {k:'benefits',l:'Top benefits',p:'List the 2–3 outcomes customers care about',wide:1},
    {k:'objection',l:'Biggest customer objection',p:'Price, trust, complexity, time, fit, etc.'},
    {k:'proof',l:'Proof available',p:'Review, demo, result, certification, before/after',wide:1},
    {k:'cta',l:'Offer / CTA',p:'What should viewers do next?'},
    {k:'assets',l:'Footage available',p:'Product video, UGC, founder, screenshots, etc.'}
  ]},
  growth_90:{kicker:'Strategy',title:'Build a 90-day growth plan',sub:'Anchor the plan to a target, a baseline and the constraint that is actually holding growth back.',display:'90-day growth strategy brief',task:'Build a practical 30/60/90-day growth plan with priorities, experiments, KPIs and decision rules.',fields:[
    {k:'baseline',l:'Current baseline',p:'Monthly revenue, leads, customers or pipeline',r:1},
    {k:'target',l:'90-day target',p:'What result do you want by day 90?',r:1},
    {k:'metrics',l:'Metrics you already know',p:'Traffic, CVR, CAC/CPA, AOV/LTV, ROAS, close rate, etc.',wide:1,area:1},
    {k:'asset',l:'Strongest existing asset',p:'Email list, organic traffic, content, product, partnerships'},
    {k:'constraint',l:'Main constraint',p:'Budget, creative, traffic, conversion, team, inventory, tracking',r:1}
  ]},
  linkedin_b2b:{kicker:'LinkedIn B2B',title:'Build a LinkedIn demand-gen brief',sub:'Define the buying committee and commercial offer before Arcline writes ads.',display:'LinkedIn B2B demand-gen brief',task:'Build a LinkedIn demand-generation campaign with audience, messaging, creative and pipeline measurement.',fields:[
    {k:'buyers',l:'Buyer roles / job titles',p:'Primary decision makers and influencers',r:1},
    {k:'firms',l:'Company profile',p:'Industry, size, geography, maturity'},
    {k:'pain',l:'Business pain we solve',p:'What costly problem are they trying to fix?',r:1,wide:1},
    {k:'offer',l:'Conversion offer',p:'Demo, audit, consultation, report, webinar',r:1},
    {k:'proof',l:'Proof available',p:'Customers, case studies, credentials — or none',wide:1},
    {k:'deal',l:'Deal value / sales cycle',p:'If known'}
  ]},
  positioning:{kicker:'Positioning',title:'Position against a competitor',sub:'Use a named competitor and defensible proof instead of vague “we are better” claims.',display:'Competitive positioning brief',task:'Create a defensible competitive positioning strategy and message hierarchy.',fields:[
    {k:'competitor',l:'Main competitor',p:'Name + website if possible',r:1},
    {k:'why',l:'Why customers choose them',p:'Known reason or your current assumption',wide:1},
    {k:'diff',l:'Your strongest differentiator',p:'What is meaningfully different?',r:1,wide:1},
    {k:'price',l:'Price position',p:'Cheaper, similar, premium, unknown'},
    {k:'proof',l:'Proof you can support',p:'Evidence behind the differentiation',wide:1},
    {k:'objection',l:'Objection to overcome',p:'Why might a buyer still choose the competitor?'}
  ]},
  google_audit:{kicker:'Google Ads',title:'Audit rising Google Ads costs',sub:'Paste before/after numbers and the campaign changes. Arcline will diagnose before prescribing.',display:'Google Ads audit brief',task:'Diagnose rising Google Ads costs and recommend the smallest evidence-based changes to test.',fields:[
    {k:'campaign',l:'Campaign type',p:'Search, PMax, Shopping, YouTube, etc.',r:1},
    {k:'period',l:'Comparison period',p:'e.g. Aug 1–14 vs Aug 15–28'},
    {k:'metrics',l:'Before → after metrics',p:'Spend, impressions/CPM, CTR, CPC, CVR, CPA, AOV/value, ROAS — include what you have.',wide:1,area:1,r:1},
    {k:'bidding',l:'Bid strategy / target changes',p:'What changed?'},
    {k:'mix',l:'Search-term / product-mix changes',p:'Anything notable or unknown',wide:1},
    {k:'tracking',l:'Tracking changes',p:'Any conversion or attribution changes?'}
  ]},
  youtube_story:{kicker:'YouTube',title:'Turn a customer story into video content',sub:'Use only facts and proof you are allowed to publish.',display:'YouTube customer-story brief',task:'Turn one verified customer story into an anchor video and a week of Shorts content.',fields:[
    {k:'story',l:'Customer story',p:'What actually happened? Use verified facts only.',r:1,wide:1,area:1},
    {k:'permission',l:'What may be publicly used?',p:'Name, quote, result, screenshots, anonymous only'},
    {k:'focus',l:'Product / service involved',p:'Specific offer'},
    {k:'problem',l:'Audience problem',p:'What pain or aspiration does the story represent?',wide:1},
    {k:'cta',l:'Desired CTA',p:'Subscribe, book, shop, download, etc.'},
    {k:'footage',l:'Footage available',p:'Interview, B-roll, product, screenshots, AI visuals'}
  ]},
  ad_copy:{kicker:'Ad Copy Lab',title:'Build an ad-copy brief',sub:'Give Arcline the offer, proof and objection before it writes copy.',display:'Ad copy brief',task:'Create three strategically different ad angles with copy, headline, CTA and creative direction.',fields:[
    {k:'focus',l:'Product / service',p:'What are we promoting?',r:1},
    {k:'offer',l:'Offer / CTA',p:'Exact commercial offer and next action',r:1},
    {k:'benefit',l:'Main benefit',p:'Outcome the customer cares about',r:1},
    {k:'proof',l:'Proof available',p:'Evidence or none',wide:1},
    {k:'objection',l:'Main objection',p:'Why might they not buy?'}
  ]},
  hooks:{kicker:'Hook Lab',title:'Build a hook brief',sub:'Specificity creates better hooks than generic “stop the scroll” prompts.',display:'Hook-generation brief',task:'Generate hooks grouped by strategic angle, then rank the strongest five.',fields:[
    {k:'topic',l:'Product / topic',p:'What is the content actually about?',r:1},
    {k:'benefit',l:'Benefit / tension',p:'Outcome, pain, contrast or curiosity',r:1},
    {k:'proof',l:'What can be shown?',p:'Demo, result, visual, process, comparison',wide:1},
    {k:'cta',l:'Desired CTA',p:'What should the viewer do?'}
  ]},
  content_calendar:{kicker:'Content Studio',title:'Build a 7-day content brief',sub:'Set one weekly business goal and one campaign focus so the calendar has a purpose.',display:'7-day content calendar brief',task:'Build a 7-day content calendar with format, hook, key points, CTA and testing objective.',fields:[
    {k:'goal',l:'Business goal this week',p:'Awareness, engagement, leads or sales',r:1},
    {k:'focus',l:'Product / campaign focus',p:'Specific product, offer or topic',r:1},
    {k:'assets',l:'Content assets available',p:'Founder, UGC, product shots, graphics, customer stories',wide:1},
    {k:'cta',l:'Desired CTA',p:'What should people do next?'}
  ]},
  budget_plan:{kicker:'Budget',title:'Build a budget-allocation brief',sub:'Arcline will allocate around economics, not arbitrary percentages.',display:'Marketing budget allocation brief',task:'Allocate the marketing budget using unit economics and clear scale/kill rules.',fields:[
    {k:'margin',l:'Gross / contribution margin',p:'Percentage or unknown'},
    {k:'value',l:'AOV / lead value',p:'Value or unknown'},
    {k:'cac',l:'Current CAC / CPA',p:'Number or unknown'},
    {k:'return',l:'Current ROAS / close rate',p:'Number or unknown'},
    {k:'target',l:'Minimum acceptable return',p:'ROAS, CAC, payback, margin target',wide:1}
  ]},
  persona:{kicker:'Audience',title:'Build evidence-aware customer personas',sub:'Use what you already know and let Arcline label the rest as assumptions.',display:'Customer persona brief',task:'Create three practical buying personas with jobs, triggers, objections, proof needs and message angles.',fields:[
    {k:'patterns',l:'Existing customer patterns',p:'Who already buys and what do they have in common?',wide:1,area:1},
    {k:'pains',l:'Known pains',p:'Problems customers mention',wide:1},
    {k:'objections',l:'Known objections',p:'Reasons they hesitate',wide:1},
    {k:'alternatives',l:'Alternatives used today',p:'Competitors, DIY, spreadsheets, agencies, etc.',wide:1}
  ]}
};
let activeBrief=null;
let briefStep=1;
const BUSINESS_FIELDS=[
  {k:'url',l:'Website',p:'https://yourstore.com',wide:1},
  {k:'name',l:'Brand name (optional)',p:'Arcline can usually detect this'},
  {k:'budget',l:'Monthly budget (optional)',p:'Leave blank for an AI recommendation',type:'number'}
];
function brandContextValue(k){
  const B=state.brand||{};
  if(k==='name')return B.name&&B.name!=='My Brand'?B.name:'';
  return String(B[k]||'').trim();
}
function briefFieldHTML(f,prefix,value){
  const cls='brief-field'+(f.wide?' wide':'');
  const id=prefix+f.k;
  const val=value!=null&&String(value)!==''?' value="'+esc(value)+'"':'';
  const label='<label for="'+id+'">'+esc(f.l)+'</label>';
  const isTask=prefix==='task_';
  const control=(isTask||f.area)
    ?'<textarea rows="2" id="'+id+'" name="'+esc(f.k)+'" placeholder="'+esc(f.p||'')+'">'+esc(value||'')+'</textarea>'
    :'<input id="'+id+'" name="'+esc(f.k)+'" type="'+(f.type||'text')+'" placeholder="'+esc(f.p||'')+'"'+val+'>';
  return '<div class="'+cls+'">'+label+control+'</div>';
}
function autoSizeBriefTextarea(el){
  if(!el||el.tagName!=='TEXTAREA')return;
  el.style.height='auto';
  const max=220;
  el.style.height=Math.min(Math.max(el.scrollHeight,86),max)+'px';
  el.style.overflowY=el.scrollHeight>max?'auto':'hidden';
}
function resizeBriefTextareas(){
  $$('#briefFields textarea').forEach(autoSizeBriefTextarea);
}
function renderBusinessFields(){
  $('#briefBusinessFields').innerHTML=BUSINESS_FIELDS.map(f=>briefFieldHTML(f,'brand_',brandContextValue(f.k))).join('');
}
function saveWebsiteInputs(form){
  const url=String(form.elements.url&&form.elements.url.value||'').trim();
  const name=String(form.elements.name&&form.elements.name.value||'').trim();
  const budget=String(form.elements.budget&&form.elements.budget.value||'').trim();
  if(url)state.brand.url=url;
  if(name)state.brand.name=name;
  if(budget)state.brand.budget=budget;
}
function applyWebsiteAnalysis(data,form){
  const b=data&&data.brand||{};
  const use=(k,v)=>{if(v&&String(v).trim())state.brand[k]=String(v).trim();};
  use('name',b.name);use('offer',b.offer);use('audience',b.audience);use('market',b.market);use('url',data.analyzedUrl||b.url);
  const manualBudget=String(form.elements.budget&&form.elements.budget.value||'').trim();
  if(manualBudget)state.brand.budget=manualBudget;
  store.set('arc.brand',state.brand);renderBrandBits();
  activeBrief.siteAnalysis=data;
  for(const f of activeBrief.def.fields){
    const el=form.elements[f.k],suggested=data.taskFields&&data.taskFields[f.k];
    if(el&&suggested&&!String(el.value||'').trim()){
      el.value=String(suggested);
      const field=el.closest('.brief-field');
      if(field){field.classList.add('ai-filled');field.classList.remove('user-edited');}
      autoSizeBriefTextarea(el);
    }
  }
  resizeBriefTextareas();
}
function renderBriefSummary(){
  const parts=[brandContextValue('name')||'Brand',brandContextValue('market')||'Market to confirm',brandContextValue('offer')||'Offer analyzed'];
  $('#briefSummary').textContent=parts.join('  •  ');
}
function setBriefStep(n){
  briefStep=n;
  $('#briefStep1').hidden=n!==1;$('#briefStep2').hidden=n!==2;
  $('#briefStepLabel1').classList.toggle('active',n===1);$('#briefStepLabel2').classList.toggle('active',n===2);
  $('#briefCancel').textContent=n===1?'Cancel':'Back';
  $('#briefGenerate').textContent=n===1?'Analyze website':'Generate with Arcline';
  $('#briefFootNote').textContent=n===1?'Arcline reads only publicly accessible website content':'Review the AI suggestions, edit anything you want, then generate';
  if(n===2){
    renderBriefSummary();
    requestAnimationFrame(()=>{
      resizeBriefTextareas();
      const first=$('#briefFields textarea, #briefFields input');
      if(first)first.focus();
    });
  }
  else requestAnimationFrame(()=>{const first=$('#briefBusinessFields input, #briefBusinessFields textarea');if(first)first.focus();});
}
function openBriefModal(id,platform,goal){
  const def=BRIEF_FORMS[id]||BRIEF_FORMS.growth_90;
  if(platform&&platform!=='all')setPlatform(platform);if(goal)setGoal(goal);
  activeBrief={id,def,platform:platform||state.platform,goal:goal||state.goal,siteAnalysis:null};
  $('#briefKicker').textContent=def.kicker||'Guided brief';
  $('#briefTitle').textContent=def.title;
  $('#briefSub').textContent='Enter the website and Arcline will prepare the brief for you.';
  renderBusinessFields();
  $('#briefFields').innerHTML=def.fields.map(f=>briefFieldHTML(f,'task_','')).join('');
  const status=$('#briefAnalyzeStatus');status.hidden=true;status.className='brief-analyze-status';
  $('#briefModal').classList.add('open');$('#briefModal').setAttribute('aria-hidden','false');document.body.classList.add('brief-open');
  setBriefStep(1);
}
function closeBriefModal(){
  $('#briefModal').classList.remove('open');$('#briefModal').setAttribute('aria-hidden','true');document.body.classList.remove('brief-open');activeBrief=null;
}
async function analyzeWebsiteAndContinue(){
  if(!activeBrief||state.generating)return;
  const form=$('#briefForm'),urlEl=form.elements.url,url=String(urlEl&&urlEl.value||'').trim();
  if(!url){urlEl.focus();toast('Enter your website first');return;}
  saveWebsiteInputs(form);
  const btn=$('#briefGenerate'),status=$('#briefAnalyzeStatus');
  btn.disabled=true;btn.textContent='Analyzing…';status.hidden=false;status.className='brief-analyze-status loading';status.textContent='Reading the website and preparing the brief…';
  try{
    const r=await fetch('/api/arcline-sophie-site-context',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
      url,brandName:String(form.elements.name&&form.elements.name.value||'').trim(),budget:String(form.elements.budget&&form.elements.budget.value||'').trim(),
      briefId:activeBrief.id,platform:state.platform,goal:state.goal
    })});
    const data=await r.json().catch(()=>({}));
    if(!r.ok)throw new Error(data.error||'Could not analyze this website.');
    applyWebsiteAnalysis(data,form);
    status.className='brief-analyze-status good';
    status.textContent='Website analyzed. Arcline prepared the campaign details from '+((data.pages&&data.pages.length)||1)+' page'+(((data.pages&&data.pages.length)||1)===1?'':'s')+'.';
    setBriefStep(2);
  }catch(err){
    status.className='brief-analyze-status bad';status.textContent=err.message||'Website analysis failed. Check the URL and try again.';toast('Could not analyze the website');
  }finally{btn.disabled=false;btn.textContent=briefStep===1?'Analyze website':'Generate with Arcline';}
}
function compileBrief(form){
  const B=state.brand||{},def=activeBrief.def,details=[];
  for(const f of def.fields){const el=form.elements[f.k],v=el?String(el.value||'').trim():'';if(v)details.push(f.l+': '+v);}
  const active=connectedChannelNames(),a=activeBrief.siteAnalysis||{},extra=[];
  if(a.siteSummary)extra.push('Website analysis: '+a.siteSummary);
  if(Array.isArray(a.categories)&&a.categories.length)extra.push('Detected categories: '+a.categories.join(', '));
  if(Array.isArray(a.proof)&&a.proof.length)extra.push('Proof/claims observed on website: '+a.proof.join(' | '));
  if(a.positioning)extra.push('Detected positioning: '+a.positioning);
  return [
    'Task: '+def.task,'Business / brand: '+(brandContextValue('name')||'Not provided'),'What we sell: '+(brandContextValue('offer')||'Not provided'),
    'Website: '+(brandContextValue('url')||'Not provided'),'Target audience: '+(brandContextValue('audience')||'Not provided'),
    'Primary market: '+(brandContextValue('market')||'Not confirmed'),
    'Monthly marketing budget: '+(brandContextValue('budget')?('$'+parseBudget(B.budget).toLocaleString('en-US')):'Not provided — recommend a sensible starter testing range'),
    'Brand voice: '+(B.voice||'Expert'),'Selected channel: '+plat(state.platform).name,'Campaign goal: '+goalOf(state.goal).name,
    'Active channels: '+(active.length?active.join(', '):'None specified'),...extra,'','Task details:',...details.map(x=>'- '+x),'',
    'Use only supplied or website-observed facts for claims, proof, testimonials and performance. Distinguish observed facts from strategy recommendations and assumptions.'
  ].join('\n');
}

const AUTO_TASKS={
  meta_ads:{kicker:'Meta Ads',display:'Create my Meta Ads campaign',title:'Building your Meta Ads campaign',done:'Your Meta Ads launch pack is ready'},
  tiktok_week:{kicker:'TikTok',display:'Plan my TikTok content',title:'Building your TikTok plan',done:'Your TikTok content pack is ready'},
  lead_funnel:{kicker:'Lead generation',display:'Build my lead funnel',title:'Building your lead funnel',done:'Your lead funnel is ready'},
  reels:{kicker:'Instagram Reels',display:'Create my Instagram Reels plan',title:'Building your Reels plan',done:'Your Reels content pack is ready'},
  growth_90:{kicker:'90-day growth',display:'Build my 90-day marketing plan',title:'Building your 90-day plan',done:'Your 90-day marketing plan is ready'},
  positioning:{kicker:'Positioning',display:'Improve my brand positioning',title:'Improving your brand positioning',done:'Your positioning plan is ready'}
};
let autoState=null,autoTimer=null,autoController=null;
function autoTask(id){return AUTO_TASKS[id]||null;}
function resetAutoSteps(){
  $$('.auto-step').forEach(x=>x.classList.remove('on','done'));
  const s=$('.auto-step[data-auto-step="1"]');if(s)s.classList.add('on');
}
function setAutoStep(n,title){
  $$('.auto-step').forEach(x=>{const k=+x.dataset.autoStep;x.classList.toggle('done',k<n);x.classList.toggle('on',k===n);});
  if(title)$('#autoProgressTitle').textContent=title;
}
function stopAutoAnalysis(){
  clearInterval(autoTimer);autoTimer=null;
  if(autoController){try{autoController.abort();}catch(e){}autoController=null;}
  $('#autoProgress').hidden=true;$('#autoInputs').hidden=false;$('#autoBuild').hidden=false;
  $('#autoBuild').disabled=false;$('#autoBuild').textContent='Build it for me';$('#autoCancel').textContent='Cancel';
  $('#autoStopped').hidden=false;$('#autoError').hidden=true;resetAutoSteps();
}
function closeAuto(){
  clearInterval(autoTimer);autoTimer=null;
  if(autoController){try{autoController.abort();}catch(e){}autoController=null;}
  $('#autoModal').classList.remove('open');$('#autoModal').setAttribute('aria-hidden','true');
  document.body.classList.remove('brief-open');autoState=null;
}
function openAuto(id,platform,goal){
  const cfg=autoTask(id);if(!cfg)return openBriefModal(id,platform,goal);
  if(platform&&platform!=='all')setPlatform(platform);if(goal)setGoal(goal);
  autoState={id,cfg,platform:platform||state.platform,goal:goal||state.goal};
  $('#autoKicker').textContent=cfg.kicker+' · Arcline Autopilot';
  $('#autoTitle').textContent=cfg.title;
  $('#autoSub').textContent='Enter the website you want to market. Arcline will read that site, make the decisions, and build the starter plan.';
  // Never silently reuse the previous brand. Every task begins with a blank URL.
  $('#autoUrl').value='';$('#autoBudget').value='';
  const savedUrl=brandContextValue('url'),savedName=brandContextValue('name'),saved=$('#autoSaved');
  if(savedUrl){
    saved.hidden=false;$('#autoSavedName').textContent=savedName||'Saved business';$('#autoSavedUrl').textContent=savedUrl;
  }else saved.hidden=true;
  $('#autoInputs').hidden=false;$('#autoProgress').hidden=true;$('#autoError').hidden=true;$('#autoStopped').hidden=true;
  $('#autoBuild').hidden=false;$('#autoBuild').disabled=false;$('#autoCancel').textContent='Cancel';resetAutoSteps();
  $('#autoModal').classList.add('open');$('#autoModal').setAttribute('aria-hidden','false');document.body.classList.add('brief-open');
  requestAnimationFrame(()=>$('#autoUrl').focus());
}
function useSavedWebsite(){
  const u=brandContextValue('url');if(!u)return;
  $('#autoUrl').value=u;
  if(brandContextValue('budget'))$('#autoBudget').value=brandContextValue('budget');
  $('#autoStopped').hidden=true;$('#autoError').hidden=true;$('#autoUrl').focus();
}
function applyAutoBrand(data,budget){
  const br=data&&data.brand||{},use=(k,v)=>{if(v&&String(v).trim())state.brand[k]=String(v).trim();};
  use('name',br.name);use('offer',br.offer);use('audience',br.audience);use('market',br.market);use('url',data.analyzedUrl||br.url);
  state.brand.budget=budget||'';
  store.set('arc.brand',state.brand);renderBrandBits();
}
function autoPrompt(data){
  const fields=data.taskFields||{},lines=[
    'AUTOPILOT_TASK: '+autoState.id,
    'Build this for a COMPLETE BEGINNER. The user should not need marketing knowledge.',
    'Business: '+(state.brand.name||'Not provided'),'Website: '+(state.brand.url||''),
    'What it sells: '+(state.brand.offer||''),'Likely audience: '+(state.brand.audience||''),
    'Market: '+(state.brand.market||'Not confirmed'),
    'User budget: '+(state.brand.budget?('$'+state.brand.budget+' per month'):'Not supplied — recommend a sensible starter test budget and label it as a recommendation'),
    'Website summary: '+(data.siteSummary||''),'Positioning observed: '+(data.positioning||''),
    'Categories: '+((data.categories||[]).join(', ')),'Website-supported proof: '+((data.proof||[]).join(' | ')),'','Website analysis suggestions:'
  ];
  Object.entries(fields).forEach(([k,v])=>{if(v)lines.push('- '+k+': '+v);});
  lines.push('','Make the decisions for the user. Explain exactly what to do from A to Z in plain English. Avoid unexplained jargon. Do not invent proof or historical performance.');
  return lines.join('\n');
}
async function runAuto(){
  if(!autoState)return;
  const url=String($('#autoUrl').value||'').trim(),budget=String($('#autoBudget').value||'').trim();
  if(!url){$('#autoUrl').focus();toast('Enter the website you want to market');return;}
  $('#autoStopped').hidden=true;$('#autoError').hidden=true;$('#autoInputs').hidden=true;$('#autoProgress').hidden=false;
  $('#autoBuild').hidden=true;$('#autoCancel').textContent='Stop';resetAutoSteps();setAutoStep(1,'Reading this website');
  let n=1;clearInterval(autoTimer);autoTimer=setInterval(()=>{if(n<3){n++;setAutoStep(n,n===2?'Choosing what will work best':'Creating the campaign');}},1000);
  autoController=new AbortController();
  try{
    const r=await fetch('/api/arcline-sophie-site-context',{method:'POST',headers:{'Content-Type':'application/json'},signal:autoController.signal,
      body:JSON.stringify({url,budget,briefId:autoState.id,platform:state.platform,goal:state.goal})});
    const data=await r.json().catch(()=>({}));
    if(!r.ok)throw new Error(data.error||'Could not read this website.');
    if(!autoState)return;
    clearInterval(autoTimer);autoTimer=null;autoController=null;setAutoStep(3,'Creating your campaign');
    applyAutoBrand(data,budget);await sleep(350);if(!autoState)return;
    setAutoStep(4,'Preparing simple launch instructions');await sleep(350);if(!autoState)return;
    const cur=autoState,text=autoPrompt(data),display=cur.cfg.display;
    closeAuto();send(text,{displayText:display,autopilot:true,task:cur.id});
  }catch(err){
    clearInterval(autoTimer);autoTimer=null;autoController=null;
    if(err&&err.name==='AbortError'){if(autoState)stopAutoAnalysis();return;}
    $('#autoProgress').hidden=true;$('#autoInputs').hidden=false;$('#autoBuild').hidden=false;$('#autoCancel').textContent='Cancel';
    $('#autoError').hidden=false;$('#autoError').textContent=err.message||'Arcline could not read that website. Check the address and try again.';
  }
}
function loadGuidedBrief(id,platform,goal){
  closeSlash();closePop();
  if(autoTask(id))openAuto(id,platform,goal);else openBriefModal(id,platform,goal);
}


/* ---------- State ---------- */
const state={
  chats:store.get('arc.chats',null),
  current:null,
  mode:store.get('arc.mode','strategist'),
  platform:'all',goal:'sales',
  brand:store.get('arc.brand',{name:'My Brand',offer:'',audience:'',url:'',market:'',budget:'',voice:'Expert'}),
  channels:store.get('arc.channels',[
    {id:'meta',name:'Meta Ads',mono:'Ma',c:'#3B5BFF',on:false},
    {id:'gads',name:'Google Ads',mono:'Ga',c:'#D99800',on:false},
    {id:'tt',name:'TikTok Ads',mono:'Tk',c:'#0FA3B1',on:false},
    {id:'shop',name:'Shopify',mono:'Sh',c:'#5E8E3E',on:false},
    {id:'ga4',name:'Google Analytics 4',mono:'G4',c:'#E37400',on:false},
    {id:'kl',name:'Klaviyo',mono:'Kl',c:'#7A7F8F',on:false}
  ]),
  generating:false,abort:null,attachments:[]
};

/* ---------- Response engine (front-end demo; replace with backend stream) ---------- */
function detectPlatform(t){
  const map=[['instagram','ig'],['reel','ig'],['tiktok','tt'],['facebook','fb'],['meta','meta'],['google','gads'],['linkedin','li'],['youtube','yt'],['shorts','yt'],['bing','ms'],['microsoft','ms'],['email','em'],['seo','seo']];
  for(const [k,v] of map){if(t.includes(k))return v;}
  return null;
}
function classify(t){
  if(/(roas|\bcpa\b|\bcpc\b|\bcpm\b|\bctr\b|ad budget|budget allocat|allocate|analytic|metric|kpi|scaling|dropp|\broi\b|performance|conversion rate|a\/b|diagnos|frequency|fatigue|rising)/.test(t))return 'metrics';
  if(/(\bads?\b|ad copy|copywrit|headline|creative|campaign|retarget|angles?)/.test(t))return 'ads';
  if(/(funnel|lead|landing|email|nurture|opt-in|magnet|webinar|sequence|quiz)/.test(t))return 'funnel';
  if(/(content|post|reel|tiktok|calendar|caption|hook|hashtag|shorts|youtube|instagram|influencer|ugc|script)/.test(t))return 'content';
  return 'strategy';
}
function buildResponse(text,meta){
  const t=text.toLowerCase();
  const kind=classify(t);
  const B=state.brand;
  const brand=B.name||'your brand';
  const pid=(meta.platform&&meta.platform!=='all')?meta.platform:detectPlatform(t);
  const b2b=/(b2b|saas|linkedin|demo|software)/.test(t);
  const total=parseBudget(B.budget);
  const money='$'+total.toLocaleString('en-US');
  const r={kind};

  if(kind==='ads'){
    const label=pid?plat(pid).name:(b2b?'LinkedIn Ads':'Meta Ads');
    const adBrand=b2b?'Your Company':brand;
    const items=b2b?[
      {angle:'Pain to relief',kicker:'Save 6 hours a week',overlay:'Six hours back. Every week.',primary:'Your team loses 6 hours a week to reports nobody reads. Automate them, and put those hours back into work that moves pipeline.',headline:'Reporting on autopilot',cta:'Book a demo',score:86},
      {angle:'Social proof',kicker:'400+ revenue teams',overlay:'Three tools. One platform.',primary:'Why 400+ revenue teams replaced three tools with one. Watch the 12-minute walkthrough their finance leads signed off on.',headline:'The stack consolidation playbook',cta:'Watch demo',score:81},
      {angle:'Offer-led',kicker:'Free pipeline audit',overlay:'30 minutes. Zero slides.',primary:'Get a free pipeline audit from our solutions team. Thirty minutes, no slides, and a written report you keep either way.',headline:'Free 30-minute pipeline audit',cta:'Book audit',score:77}
    ]:[
      {angle:'Pain to relief',kicker:'Fresh roast, every week',overlay:'Roasted Monday. Yours by Thursday.',primary:'Your 3pm coffee shouldn\u2019t taste like an apology. Small-batch beans, roasted Monday and on your doorstep by Thursday.',headline:'Roasted Monday. Yours by Thursday.',cta:'Shop now',score:88},
      {angle:'Social proof',kicker:'12,000+ subscribers',overlay:'Caf\u00e9 quality. Kitchen price.',primary:'\u201cI cancelled my caf\u00e9 habit in week two.\u201d Join 12,000+ subscribers brewing caf\u00e9-quality coffee at home for less than a daily latte.',headline:'The subscription people switch to',cta:'Learn more',score:84},
      {angle:'Offer-led',kicker:'New subscribers only',overlay:'Your first bag is on us.',primary:'First bag on us. Pick your roast, pause anytime, and taste the difference fresh actually makes.',headline:'Your first bag is free',cta:'Claim offer',score:79}
    ];
    r.steps=['Reading brand context','Identifying buying motives','Drafting ad angles','Scoring opening lines'];
    r.blocks=[
      {type:'text',md:`Here are three ad angles for **${label}**, each built around a different buying motive. Run them against each other and you will learn *why* people convert, not just which ad won.`},
      {type:'ads',title:'Ad angles for '+label,badge:'Pre-launch score',brand:adBrand,items},
      {type:'text',md:`### How to launch the test
1. **One campaign, three ad sets.** Isolate each angle so the algorithm doesn't starve two of them on day one.
2. **Split spend evenly for 4 to 5 days**, then shift budget toward the lowest cost per ${b2b?'booked demo':'purchase'}.
3. **Kill rule:** pause any ad that spends 2x your target ${b2b?'cost per demo':'CPA'} without converting.
4. **Iterate the winner.** Keep the angle and test three new opening lines against it.

Want the matching landing page headline and retargeting ads for people who clicked but didn't convert?`}
    ];
    r.followups=['Write retargeting ads for people who didn\u2019t convert','Write the matching landing page headline','Suggest audiences to test these angles against'];
  }
  else if(kind==='content'){
    const d0=new Date();
    const plan=[
      {p:'ig',f:'Reel',t:'Testing 5 barista \u201csecrets\u201d at home'},
      {p:'tt',f:'TikTok',t:'Supermarket beans vs. fresh roast, blind test'},
      {p:'ig',f:'Carousel',t:'Brew-ratio cheat sheet people save'},
      {p:'yt',f:'Short',t:'What $4 vs. $1.20 per cup actually gets you'},
      {p:'tt',f:'TikTok',t:'Roastery behind the scenes at 6am'},
      {p:'ig',f:'Story poll',t:'Light, medium or dark? Let followers vote'},
      {p:'em',f:'Email',t:'Weekend brew guide with first-bag offer'}
    ];
    const days=plan.map((x,i)=>{const d=new Date(d0);d.setDate(d0.getDate()+i);return Object.assign({d:d.toLocaleDateString('en-US',{weekday:'short'}),n:d.getDate()},x);});
    r.steps=['Reviewing format trends','Writing hooks','Ranking hook strength','Building the weekly calendar'];
    r.blocks=[
      {type:'text',md:`Here's a week of short-form content for **${brand}**, led by hooks written to earn the first two seconds. Scores rank each hook on curiosity, specificity and tension. Treat them as a starting order and let retention data make the final call.`},
      {type:'hooks',title:'Hook bank, ranked',badge:'Pattern score',items:[
        {text:'I tested 5 \u201cbarista secrets\u201d at home. Only one actually worked.',format:'Reel, experiment',p:'ig',score:91},
        {text:'Stop buying coffee from the supermarket. Here\u2019s what\u2019s in the bag.',format:'TikTok, contrarian',p:'tt',score:88},
        {text:'What $4 a day gets you vs. what $1.20 gets you.',format:'Short, comparison',p:'yt',score:84},
        {text:'The one mistake that makes every home coffee taste bitter.',format:'Carousel, mistake',p:'ig',score:82},
        {text:'POV: your coffee arrives 72 hours after it was roasted.',format:'Reel, POV',p:'ig',score:76}
      ]},
      {type:'calendar',title:'7-day content calendar',badge:pid?plat(pid).name:'Multi-channel',days},
      {type:'text',md:`### Posting rhythm
- **Repurpose, don't recreate.** Every Reel ships as a TikTok and a YouTube Short with native captions.
- **Hashtags:** 3 to 5 specific tags like #homebarista beat 30 generic ones.
- **Judge hooks on 3-second hold rate**, not likes. Likes lag; retention tells you what to make next.

I can expand this into a 30-day calendar with scripts, captions and on-screen text.`}
    ];
    r.followups=['Expand this into a 30-day calendar','Write scripts for the top 3 hooks','Suggest a hashtag set for each platform'];
  }
  else if(kind==='metrics'){
    r.steps=['Modelling the spend curve','Checking fatigue signals','Separating audience and creative issues','Drafting the fix'];
    r.blocks=[
      {type:'text',md:`Let's diagnose it properly. Below is an **illustrative model** of the pattern that usually shows up when spend is scaled too quickly. Connect your ad accounts in Brand context and I'll run the same diagnosis on live data.`},
      {type:'kpis',title:'Account health, last 8 weeks',badge:'Sample data',items:[
        {l:'ROAS',v:'2.4x',d:'\u221231%',bad:true,s:[3.6,3.5,3.4,3.0,2.7,2.5,2.4,2.4]},
        {l:'Cost per purchase',v:'$38.20',d:'+44%',bad:true,s:[26,26.5,27,30,33,36,37.5,38.2]},
        {l:'Click-through rate',v:'1.12%',d:'\u221218%',bad:true,s:[1.37,1.35,1.33,1.25,1.2,1.16,1.13,1.12]},
        {l:'Frequency',v:'3.8',d:'+1.6',bad:true,s:[2.2,2.3,2.5,2.9,3.2,3.5,3.7,3.8]}
      ]},
      {type:'chart',title:'Daily spend vs. ROAS',badge:'Illustrative',labels:['W1','W2','W3','W4','W5','W6','W7','W8'],spend:[120,150,180,260,340,420,480,520],roas:[3.6,3.5,3.4,3.0,2.7,2.5,2.4,2.4]},
      {type:'text',md:`### What this pattern usually means
1. **Frequency fatigue.** As spend rises, the same people see your ads more often. Watch prospecting frequency once it climbs past about 3.
2. **Audience saturation.** Your best buyers convert first; extra budget reaches colder, more expensive people.
3. **Learning resets.** Budget jumps above roughly 20% at once can push ad sets back into the learning phase.

### Recommended fix
- Scale in **15 to 20% steps** every 48 to 72 hours instead of large jumps.
- Refresh creative on your top ad sets **every 10 to 14 days**.
- Move 20 to 30% of spend to **broad targeting** and let strong creative do the targeting.

Want a week-by-week scaling schedule for your ${money} monthly budget?`}
    ];
    r.followups=['Build a scaling schedule for '+money+' a month','How do I spot creative fatigue early?','Set up an A/B test for new creatives'];
  }
  else if(kind==='funnel'){
    r.steps=['Mapping the customer journey','Designing the capture offer','Sequencing nurture emails','Planning automations'];
    r.blocks=[
      {type:'text',md:`Here's a full-funnel system for **${brand}**. Each stage has one job and one metric that tells you whether it's doing it.`},
      {type:'funnel',title:'Acquisition funnel',badge:'5 stages',stages:[
        {name:'Attract',tactic:'Short-form video and Meta prospecting ads',kpi:'Thumb-stop rate',w:100},
        {name:'Capture',tactic:'Quiz landing page: find your perfect roast',kpi:'Opt-in rate',w:80},
        {name:'Nurture',tactic:'5-email welcome sequence over 10 days',kpi:'Email click rate',w:62},
        {name:'Convert',tactic:'First-bag-free offer with cart recovery',kpi:'Purchase rate',w:45},
        {name:'Expand',tactic:'Subscription upgrade and referral credit',kpi:'90-day customer value',w:30}
      ]},
      {type:'text',md:`### Why a quiz instead of a discount popup
A quiz collects **preference data** (roast, brew method, budget) that personalises every email after it. Discount popups mostly train people to wait for a code.

### Automations to switch on
- **Abandoned quiz:** reminder email one hour later
- **Viewed product, didn't buy:** 7 days of retargeting with social-proof creative
- **Subscriber on day 25:** a skip, swap or upgrade email to reduce churn

Shall I write the quiz questions and the 5-email welcome sequence?`}
    ];
    r.followups=['Write the 5-email welcome sequence','Draft the quiz questions and results','Estimate cost per lead by channel'];
  }
  else{
    r.steps=['Reading brand context','Weighing channel mix','Allocating budget','Building a 90-day roadmap'];
    r.blocks=[
      {type:'text',md:`Here's a focused 90-day growth plan for **${brand}**. Instead of spreading thin across every channel, it concentrates spend where it's most likely to pay back first, then compounds with content and retention.`},
      {type:'road',title:'90-day roadmap',badge:'3 phases',phases:[
        {w:'Weeks 1 to 2',t:'Foundation',items:['Pixel, events and tracking audit','Three customer personas','Offer and positioning test']},
        {w:'Weeks 3 to 6',t:'Acquisition',items:['Meta and TikTok creative testing','Google Search on high-intent terms','Weekly content engine']},
        {w:'Weeks 7 to 12',t:'Scale and retain',items:['Scale winning ad sets in steps','Email and SMS flows','Referral and UGC program']}
      ]},
      {type:'alloc',title:'Starting budget split for '+money+' a month',badge:'Recommended',total,items:[
        {name:'Meta Ads',note:'Prospecting and retargeting',pct:55,c:'var(--accent)'},
        {name:'Google Search',note:'Capture existing demand',pct:25,c:'var(--graphite)'},
        {name:'TikTok Ads',note:'Creative testing',pct:15,c:'var(--pink)'},
        {name:'Experiments',note:'Creators and new placements',pct:5,c:'var(--mark)'}
      ]},
      {type:'text',md:`### The one number to watch
**Blended acquisition cost against first-order profit.** If a new customer costs more than they return on day one, retention has to close the gap, so track 60-day customer value from the first week.

Where would you like to start: ad creative, content, or the funnel?`}
    ];
    r.followups=['Create 3 customer personas','Run a competitor positioning analysis','Turn phase 1 into a task checklist'];
  }
  return r;
}

/* ---------- Markdown ---------- */
const CARET='\uE000';
function inline(s){
  return esc(s).replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>').replace(/(^|[^*\w])\*(?!\s)([^*]+?)\*(?!\*)/g,'$1<em>$2</em>').replace(/`(.+?)`/g,'<code>$1</code>');
}
function md(src){
  const lines=src.split('\n');let out='',list=null;
  const close=()=>{if(list){out+='</'+list+'>';list=null;}};
  for(const raw of lines){
    const line=raw.replace(/\s+$/,'');let m;
    if((m=line.match(/^###\s+(.*)/))){close();out+='<h3>'+inline(m[1])+'</h3>';}
    else if((m=line.match(/^\d+\.\s+(.*)/))){if(list!=='ol'){close();out+='<ol>';list='ol';}out+='<li>'+inline(m[1])+'</li>';}
    else if((m=line.match(/^-\s+(.*)/))){if(list!=='ul'){close();out+='<ul>';list='ul';}out+='<li>'+inline(m[1])+'</li>';}
    else if(!line.trim()){close();}
    else{close();out+='<p>'+inline(line)+'</p>';}
  }
  close();return out;
}

/* ---------- Block renderers ---------- */
function card(title,badge,inner){
  return '<section class="card"><header class="card-h"><div class="card-t">'+title+'</div>'+(badge?'<span class="badge">'+esc(badge)+'</span>':'')+'</header><div class="card-b">'+inner+'</div></section>';
}
function smooth(p){
  let d='M'+p[0][0].toFixed(1)+' '+p[0][1].toFixed(1);
  for(let i=0;i<p.length-1;i++){
    const p0=p[i-1]||p[i],p1=p[i],p2=p[i+1],p3=p[i+2]||p2;
    const c1x=p1[0]+(p2[0]-p0[0])/6,c1y=p1[1]+(p2[1]-p0[1])/6,c2x=p2[0]-(p3[0]-p1[0])/6,c2y=p2[1]-(p3[1]-p1[1])/6;
    d+=' C'+c1x.toFixed(1)+' '+c1y.toFixed(1)+' '+c2x.toFixed(1)+' '+c2y.toFixed(1)+' '+p2[0].toFixed(1)+' '+p2[1].toFixed(1);
  }
  return d;
}
function spark(vals){
  const w=120,h=38,pad=5,mn=Math.min(...vals),mx=Math.max(...vals),r=(mx-mn)||1;
  const pts=vals.map((v,i)=>[i*w/(vals.length-1),pad+(h-pad*2)*(1-(v-mn)/r)]);
  const line=smooth(pts);
  return {line,area:line+' L'+w+' '+h+' L0 '+h+' Z'};
}
const CH={W:640,H:230,pl:36,pr:14,pt:14,pb:28};
function blkAds(b){
  const url=(b.brand||'brand').toLowerCase().replace(/[^a-z0-9]/g,'')+'.com';
  const initial=esc((b.brand||'B').charAt(0).toUpperCase());
  return card(ic('megaphone',15)+esc(b.title),b.badge,'<div class="ads">'+b.items.map((a,i)=>
    '<article class="ad">'+
      '<div class="ad-top"><span class="ad-av">'+initial+'</span><span class="ad-id"><span class="ad-brand">'+esc(b.brand)+'</span><span class="ad-sp">Sponsored</span></span><button class="mini-btn" aria-label="Copy ad copy" data-copy="'+esc(a.primary+'\n\nHeadline: '+a.headline+'\nCTA: '+a.cta)+'">'+ic('copy',14)+'</button></div>'+
      '<p class="ad-primary">'+esc(a.primary)+'</p>'+
      '<div class="ad-media v'+(i+1)+'"><div class="ad-media-in"><span class="ad-kicker">'+esc(a.kicker)+'</span><span class="ad-big">'+esc(a.overlay)+'</span></div></div>'+
      '<div class="ad-bottom"><div class="ad-bt"><div class="ad-url">'+esc(url)+'</div><div class="ad-head">'+esc(a.headline)+'</div></div><span class="ad-cta">'+esc(a.cta)+'</span></div>'+
      '<div class="ad-meta"><span class="angle">'+esc(a.angle)+'</span><span class="score"><span class="score-bar"><i style="--w:'+a.score+'%"></i></span><b>'+a.score+'</b></span></div>'+
    '</article>').join('')+'</div>');
}
function blkHooks(b){
  return card(ic('zap',15)+esc(b.title),b.badge,'<div class="hooks">'+b.items.map((h,i)=>
    '<div class="hook"><span class="rank">'+(i+1)+'</span><div class="hook-main"><p>'+esc(h.text)+'</p><div class="hook-meta">'+monoChip(h.p)+'<span>'+esc(h.format)+'</span></div></div><div class="ring" style="--p:'+h.score+'"><span>'+h.score+'</span></div><button class="mini-btn" aria-label="Copy hook" data-copy="'+esc(h.text)+'">'+ic('copy',14)+'</button></div>').join('')+'</div>');
}
function blkCal(b){
  return card(ic('calendar',15)+esc(b.title),b.badge,'<div class="cal">'+b.days.map((d,i)=>
    '<div class="day'+(i===0?' is-first':'')+'"><div class="day-h"><span>'+esc(d.d)+'</span><b>'+d.n+'</b></div>'+monoChip(d.p)+'<div class="day-f">'+esc(d.f)+'</div><div class="day-t">'+esc(d.t)+'</div></div>').join('')+'</div>');
}
function blkKpis(b){
  return card(ic('trending',15)+esc(b.title),b.badge,'<div class="kpis">'+b.items.map(k=>{
    const s=spark(k.s);const cls=k.bad?'bad':'good';
    return '<div class="kpi"><div class="kpi-l">'+esc(k.l)+'</div><div class="kpi-v">'+esc(k.v)+'</div><span class="delta '+cls+'">'+esc(k.d)+'</span><svg class="spark '+cls+'" viewBox="0 0 120 38" preserveAspectRatio="none" aria-hidden="true"><path class="a" d="'+s.area+'"/><path class="l" vector-effect="non-scaling-stroke" d="'+s.line+'"/></svg></div>';
  }).join('')+'</div>');
}
function chartX(i,n){return CH.pl+i*(CH.W-CH.pl-CH.pr)/(n-1);}
function blkChart(b){
  const {W,H,pl,pr,pt,pb}=CH,n=b.labels.length;
  const maxS=Math.max(...b.spend)*1.15,maxR=4;
  const yS=v=>pt+(H-pt-pb)*(1-v/maxS),yR=v=>pt+(H-pt-pb)*(1-v/maxR);
  let grid='',ax='';
  for(let k=0;k<=4;k++){const y=pt+(H-pt-pb)*k/4;grid+='<line class="grid" x1="'+pl+'" x2="'+(W-pr)+'" y1="'+y+'" y2="'+y+'"/>';ax+='<text class="ax" x="'+(pl-8)+'" y="'+(y+4)+'" text-anchor="end">'+(maxR*(1-k/4)).toFixed(0)+'x</text>';}
  b.labels.forEach((l,i)=>{ax+='<text class="ax" x="'+chartX(i,n)+'" y="'+(H-8)+'" text-anchor="middle">'+esc(l)+'</text>';});
  const sp=b.spend.map((v,i)=>[chartX(i,n),yS(v)]);
  const spendLine=smooth(sp);
  const spendArea=spendLine+' L'+chartX(n-1,n)+' '+(H-pb)+' L'+chartX(0,n)+' '+(H-pb)+' Z';
  const roasPath=smooth(b.roas.map((v,i)=>[chartX(i,n),yR(v)]));
  const pts=b.roas.map((v,i)=>'<circle class="pt" cx="'+chartX(i,n)+'" cy="'+yR(v)+'" r="3.5" style="--i:'+i+'"/>').join('');
  const step=(W-pl-pr)/(n-1);
  const hits=b.labels.map((l,i)=>'<div data-i="'+i+'" style="left:'+((chartX(i,n)-step/2)/W*100).toFixed(3)+'%;width:'+(step/W*100).toFixed(3)+'%"></div>').join('');
  return card(ic('chart',15)+esc(b.title),b.badge,
    '<div class="legend"><span><i style="--c:var(--accent)"></i>ROAS</span><span><i style="--c:var(--graphite)"></i>Daily spend</span></div>'+
    '<div class="chart-wrap"><svg class="chart" viewBox="0 0 '+W+' '+H+'" role="img" aria-label="ROAS falls as daily spend rises over eight weeks">'+grid+
    '<path class="spend-a" d="'+spendArea+'"/><path class="spend-l" d="'+spendLine+'"/><path class="roas" pathLength="1" d="'+roasPath+'"/>'+pts+ax+
    '<line class="guide" x1="0" x2="0" y1="'+pt+'" y2="'+(H-pb)+'"/></svg><div class="chart-hit">'+hits+'</div><div class="tip"></div></div>');
}
function blkFunnel(b){
  return card(ic('funnel',15)+esc(b.title),b.badge,'<div class="funnel">'+b.stages.map((s,i)=>
    '<div class="fs"><div class="fs-vis"><div class="fs-bar" style="--w:'+s.w+'%;--i:'+i+'">'+esc(s.name)+'</div></div><div class="fs-info"><div class="fs-t">'+esc(s.tactic)+'</div><div class="fs-k">'+ic('target',12)+esc(s.kpi)+'</div></div></div>').join('')+'</div>');
}
function blkRoad(b){
  return card(ic('road',15)+esc(b.title),b.badge,'<div class="road">'+b.phases.map((p,i)=>
    '<div class="ph"><div class="ph-top"><span class="ph-n">'+(i+1)+'</span><span class="ph-w">'+esc(p.w)+'</span></div><div class="ph-t">'+esc(p.t)+'</div><ul>'+p.items.map(x=>'<li>'+esc(x)+'</li>').join('')+'</ul></div>').join('')+'</div>');
}
function blkAlloc(b){
  const total=b.total||6000;
  return card(ic('pie',15)+esc(b.title),b.badge,
    '<div class="alloc-bar">'+b.items.map(it=>'<i style="--w:'+it.pct+'%;--c:'+it.c+'" title="'+esc(it.name)+'"></i>').join('')+'</div>'+
    '<div class="alloc-legend">'+b.items.map(it=>'<div class="al"><span class="sw" style="--c:'+it.c+'"></span><span class="al-n">'+esc(it.name)+'<small>'+esc(it.note)+'</small></span><b>'+it.pct+'%</b><em>$'+Math.round(total*it.pct/100).toLocaleString('en-US')+'</em></div>').join('')+'</div>');
}

function platformLaunchUrl(name){
  const n=String(name||'').toLowerCase();
  if(n.includes('meta')||n.includes('facebook')||n.includes('instagram'))return ['Open Meta Ads Manager','https://business.facebook.com/adsmanager/'];
  if(n.includes('tiktok'))return ['Open TikTok Ads Manager','https://ads.tiktok.com/'];
  if(n.includes('google'))return ['Open Google Ads','https://ads.google.com/'];
  if(n.includes('linkedin'))return ['Open LinkedIn Campaign Manager','https://www.linkedin.com/campaignmanager/'];
  return null;
}
function blkLaunch(b){
  const plans=(b.plan||[]).slice(0,8).map(x=>'<div class="launch-plan-item"><small>'+esc(x.label||'')+'</small><b>'+esc(x.value||'')+'</b>'+(x.why?'<p>'+esc(x.why)+'</p>':'')+'</div>').join('');
  const creatives=(b.creatives||[]).slice(0,6).map((x,i)=>{
    const copy=[x.hook,x.primary,x.headline,x.cta].filter(Boolean).join('\\n\\n');
    return '<div class="launch-creative"><button class="mini-btn" data-copy="'+esc(copy)+'" aria-label="Copy creative">'+ic('copy',14)+'</button><h4>'+esc(x.title||('Idea '+(i+1)))+'</h4><dl>'+
      (x.hook?'<dt>Hook</dt><dd>'+esc(x.hook)+'</dd>':'')+
      (x.primary?'<dt>Copy / script</dt><dd>'+esc(x.primary)+'</dd>':'')+
      (x.headline?'<dt>Headline</dt><dd>'+esc(x.headline)+'</dd>':'')+
      (x.cta?'<dt>Call to action</dt><dd>'+esc(x.cta)+'</dd>':'')+
      (x.visual?'<dt>What to show</dt><dd>'+esc(x.visual)+'</dd>':'')+
    '</dl></div>';
  }).join('');
  const setup=(b.setup||[]).slice(0,14).map(x=>'<div class="launch-step"><div><b>'+esc(x.title||'Do this')+'</b><p>'+esc(x.detail||'')+'</p></div></div>').join('');
  const watch=(b.watch||[]).slice(0,8).map(x=>'<div class="launch-watch-row"><b>'+esc(x.when||'Check')+'</b><p>'+esc((x.check||'')+(x.action?' '+x.action:''))+'</p></div>').join('');
  const terms=(b.terms||[]).slice(0,10).map(x=>'<div class="launch-term"><b>'+esc(x.term||'')+'</b><span>'+esc(x.meaning||'')+'</span></div>').join('');
  const link=platformLaunchUrl(b.platform);
  return '<div class="launch-pack">'+
    '<section class="launch-hero"><div class="launch-top"><div><div class="launch-eyebrow">Arcline Autopilot</div><h3 class="launch-title">'+esc(b.title||'Your marketing launch pack')+'</h3></div><span class="launch-status">Ready</span></div><p class="launch-intro">'+esc(b.intro||'')+'</p><div class="launch-plan">'+plans+'</div>'+(b.next?'<div class="launch-next">'+ic('arrow-up',15)+'<span><b>Start here:</b> '+esc(b.next)+'</span></div>':'')+(link?'<a class="launch-platform-link" href="'+link[1]+'" target="_blank" rel="noopener">'+ic('globe',14)+esc(link[0])+'</a>':'')+'</section>'+
    (creatives?'<details class="launch-sec" open><summary><span class="num">1</span><span>Ready-to-use creative</span><span class="sum-sub">'+(b.creatives||[]).length+' ideas</span></summary><div class="launch-content"><div class="launch-creatives">'+creatives+'</div></div></details>':'')+
    (setup?'<details class="launch-sec"><summary><span class="num">2</span><span>Exactly how to set it up</span><span class="sum-sub">click-by-click</span></summary><div class="launch-content"><div class="launch-steps">'+setup+'</div></div></details>':'')+
    (watch?'<details class="launch-sec"><summary><span class="num">3</span><span>What to do after launch</span><span class="sum-sub">no guesswork</span></summary><div class="launch-content"><div class="launch-watch">'+watch+'</div></div></details>':'')+
    (terms?'<details class="launch-sec"><summary><span class="num">?</span><span>Marketing words explained</span><span class="sum-sub">plain English</span></summary><div class="launch-content"><div class="launch-gloss">'+terms+'</div></div></details>':'')+
  '</div>';
}
function renderBlock(b){
  const map={ads:blkAds,hooks:blkHooks,calendar:blkCal,kpis:blkKpis,chart:blkChart,funnel:blkFunnel,road:blkRoad,alloc:blkAlloc,launch:blkLaunch};
  const w=document.createElement('div');w.innerHTML=(map[b.type]||(()=>''))(b);
  const node=w.firstElementChild||document.createElement('div');
  if(b.type==='chart')bindChart(node,b);
  return node;
}
function bindChart(node,b){
  const wrap=node.querySelector('.chart-wrap');if(!wrap)return;
  const tip=wrap.querySelector('.tip'),guide=wrap.querySelector('.guide'),n=b.labels.length;
  wrap.querySelectorAll('.chart-hit div').forEach(h=>{
    h.addEventListener('mouseenter',()=>{
      const i=+h.dataset.i,x=chartX(i,n);
      guide.setAttribute('x1',x);guide.setAttribute('x2',x);guide.style.opacity=1;
      tip.innerHTML='<div>Week '+(i+1)+'</div><div>ROAS <b>'+b.roas[i].toFixed(1)+'x</b></div><div>Spend <b>$'+b.spend[i]+' a day</b></div>';
      tip.style.left=Math.min(Math.max(x/CH.W*100,14),86)+'%';tip.style.opacity=1;
    });
  });
  wrap.addEventListener('mouseleave',()=>{tip.style.opacity=0;guide.style.opacity=0;});
}

/* ---------- DOM refs ---------- */
const app=$('#app'),stage=$('#stage'),thread=$('#thread'),composer=$('#composer'),input=$('#input'),sendBtn=$('#sendBtn');
const heroSlot=$('#heroSlot'),dockSlot=$('#dockSlot'),slash=$('#slash'),pop=$('#pop'),toastEl=$('#toast');
const histEl=$('#history'),searchInput=$('#search'),sgEl=$('#suggest'),focusEl=$('#focusRow'),jump=$('#jump');

/* ---------- Utilities ---------- */
let tt;
function toast(msg){toastEl.innerHTML=ic('check',15)+'<span>'+esc(msg)+'</span>';toastEl.classList.add('show');clearTimeout(tt);tt=setTimeout(()=>toastEl.classList.remove('show'),2200);}
function copyText(t){
  const done=()=>toast('Copied to clipboard');
  const fallback=()=>{try{const ta=document.createElement('textarea');ta.value=t;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();document.execCommand('copy');ta.remove();done();}catch(e){toast('Copy is blocked in this browser');}};
  if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(done).catch(fallback);}else fallback();
}
function nearBottom(){return stage.scrollHeight-stage.scrollTop-stage.clientHeight<160;}
function scrollToBottom(force){if(force||nearBottom())stage.scrollTo({top:stage.scrollHeight,behavior:force&&!reduced?'smooth':'auto'});}
function fineFocus(){if(matchMedia('(pointer: fine)').matches)input.focus();}
function save(){state.chats=state.chats.slice(0,30);store.set('arc.chats',state.chats);}
function uid(){return 'c'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);}
function currentChat(){return state.chats.find(c=>c.id===state.current)||null;}
function timeLabel(ts){try{return new Date(ts).toLocaleTimeString([],{hour:'numeric',minute:'2-digit'});}catch(e){return '';}}

/* ---------- Seeds ---------- */
function makeChat(prompt,platform,ago){
  const um={role:'user',text:prompt,platform,goal:'sales',files:[]};
  const res=buildResponse(prompt,um);
  const created=Date.now()-ago;
  return {id:uid(),title:titleFrom(prompt),platform:platform!=='all'?platform:(detectPlatform(prompt.toLowerCase())||'all'),created,
    messages:[um,{role:'ai',kind:res.kind,steps:res.steps,blocks:res.blocks,followups:res.followups,mode:'strategist',ts:created+9000}]};
}
function titleFrom(t){t=t.replace(/\s+/g,' ').trim();t=t.charAt(0).toUpperCase()+t.slice(1);return t.length>44?t.slice(0,42).trim()+'\u2026':t;}
if(!Array.isArray(state.chats)){
  state.chats=[];
  save();
}

/* ---------- Rendering: history, studios, suggestions ---------- */
function renderHistory(){
  const q=searchInput.value.trim().toLowerCase(),now=Date.now(),day=864e5;
  const groups=[['Today',[]],['Previous 7 days',[]],['Earlier',[]]];
  state.chats.filter(c=>!q||c.title.toLowerCase().includes(q)).forEach(c=>{const age=now-c.created;(age<day?groups[0][1]:age<7*day?groups[1][1]:groups[2][1]).push(c);});
  const html=groups.filter(g=>g[1].length).map(g=>'<div class="sb-label">'+g[0]+'</div>'+g[1].map(c=>
    '<div class="hist'+(c.id===state.current?' on':'')+'" role="button" tabindex="0" data-id="'+c.id+'"><span class="dot" style="--c:'+plat(c.platform).c+'"></span><span class="h-t">'+esc(c.title)+'</span><button class="h-x" data-del="'+c.id+'" aria-label="Delete conversation">'+ic('x',13)+'</button></div>').join('')).join('');
  histEl.innerHTML=html||'<div class="sb-label">Recent</div><div class="hist-empty">'+(q?'No conversations match that search.':'Your conversations will appear here.')+'</div>';
}
$('#studios').innerHTML=STUDIOS.map((s,i)=>'<button class="studio" data-studio="'+i+'"><span class="s-ic">'+ic(s.icon,14)+'</span>'+esc(s.name)+'</button>').join('');

let sgOffset=0;
function renderSuggest(){
  const list=[];for(let i=0;i<6;i++)list.push(SUGGEST[(sgOffset+i)%SUGGEST.length]);
  sgEl.innerHTML=list.map(s=>'<button class="sg" data-brief="'+s.id+'" data-p="'+s.p+'" data-goal="'+s.goal+'">'+monoChip(s.p)+'<span class="sg-txt"><span class="sg-text">'+esc(s.text)+'</span><span class="sg-tag">'+esc(s.tag)+'</span></span></button>').join('');
}
function renderFocus(){
  focusEl.innerHTML=FOCUS.map(id=>{const P=plat(id);return '<button class="fchip'+(state.platform===id?' on':'')+'" data-f="'+id+'" aria-pressed="'+(state.platform===id)+'">'+monoChip(id)+esc(P.name)+'</button>';}).join('');
}
function renderBrandBits(){
  const B=state.brand,initial=esc((B.name||'B').charAt(0).toUpperCase());
  $('#wsAv').textContent=(B.name||'B').charAt(0).toUpperCase();
  $('#wsName').textContent=B.name||'Untitled brand';
  $('#wsSub').textContent=B.offer||'Brand workspace';
  const budgetLabel=String(B.budget||'').trim()?'$'+parseBudget(B.budget).toLocaleString('en-US')+' a month':'Budget not set';$('#brandChip').innerHTML='<span class="ws-av">'+initial+'</span><b>'+esc(B.name||'My Brand')+'</b><span class="hide-sm">'+esc(B.offer)+'</span><span>'+budgetLabel+'</span>'+ic('pen',13);
  const on=state.channels.filter(c=>c.on).length;
  $('#syncTxt').textContent=on+(on===1?' channel':' channels')+' active';
}

/* ---------- Messages ---------- */
function renderUser(m){
  const el=document.createElement('div');el.className='msg user';
  const P=plat(m.platform),G=goalOf(m.goal);
  el.innerHTML='<div class="u-wrap"><div class="bubble">'+esc(m.displayText||m.text)+'</div><div class="u-meta">'+
    (m.files&&m.files.length?'<span>'+ic('paperclip',12)+m.files.length+(m.files.length>1?' files':' file')+'</span>':'')+
    '<span>'+monoChip(m.platform)+esc(P.name)+'</span><span>'+ic(G.icon,12)+esc(G.name)+'</span></div></div>';
  return el;
}
function aiShell(msg,idx){
  const M=modeOf(msg.mode);
  const el=document.createElement('div');el.className='msg ai';el.dataset.idx=idx;
  el.innerHTML='<span class="avatar mark">'+MARK_SVG+'</span><div class="ai-body"><div class="ai-head"><span class="ai-name">Sophie</span><span class="mode-tag">'+ic(M.icon,12)+esc(M.name)+'</span><span class="ai-time">'+timeLabel(msg.ts||Date.now())+'</span></div><div class="trace"></div><div class="ai-content"></div><div class="ai-foot"></div></div>';
  return el;
}
function traceDone(steps,stopped){
  steps=(steps||[]).filter(Boolean);
  if(!stopped&&!steps.length)return '';
  const label=stopped?'Stopped':('Built in '+steps.length+(steps.length===1?' step':' steps'));
  return '<button class="trace-sum" aria-expanded="false">'+ic(stopped?'x':'check',14)+'<span class="trace-label">'+label+'</span><span class="chev">'+ic('chevron-down',14)+'</span></button><div class="trace-steps"><div class="ts-in">'+steps.map(s=>'<div class="tstep">'+ic('check',13)+'<span>'+esc(s)+'</span></div>').join('')+'</div></div>';
}
function footHTML(msg,isLast){
  return '<div class="acts"><button class="act" data-act="copy" aria-label="Copy response" title="Copy">'+ic('copy',15)+'</button><button class="act" data-act="regen" aria-label="Regenerate" title="Regenerate">'+ic('refresh',15)+'</button><button class="act" data-act="up" aria-label="Good response" title="Good response">'+ic('thumbs-up',15)+'</button><button class="act" data-act="down" aria-label="Poor response" title="Poor response">'+ic('thumbs-down',15)+'</button><span class="act-sep"></span><button class="act act-txt" data-act="save">'+ic('layers',14)+'<span>Save to playbook</span></button></div>'+
    (isLast&&msg.followups&&msg.followups.length?'<div class="followups">'+msg.followups.map(f=>'<button class="fu" data-fu="'+esc(f)+'">'+ic('corner',14)+'<span>'+esc(f)+'</span></button>').join('')+'</div>':'');
}
function renderAIStatic(msg,idx,isLast){
  const el=aiShell(msg,idx);
  el.querySelector('.trace').innerHTML=traceDone(msg.steps||[],msg.stopped);
  const c=el.querySelector('.ai-content');
  (msg.blocks||[]).forEach(b=>{if(b.type==='text'){const d=document.createElement('div');d.className='md';d.innerHTML=md(b.md);c.appendChild(d);}else c.appendChild(renderBlock(b));});
  el.querySelector('.ai-foot').innerHTML=footHTML(msg,isLast);
  return el;
}

function blockHistoryText(b){
  if(!b)return '';
  if(b.type==='text')return b.md||'';
  if(b.type==='launch'){
    const lines=[
      'Previous Arcline launch pack: '+(b.title||''),
      'Platform: '+(b.platform||'')
    ];
    (b.plan||[]).slice(0,8).forEach(x=>lines.push((x.label||'Plan')+': '+(x.value||'')+(x.why?' — '+x.why:'')));
    (b.creatives||[]).slice(0,4).forEach((x,i)=>lines.push('Creative '+(i+1)+': '+[x.title,x.hook,x.primary,x.headline,x.cta,x.visual].filter(Boolean).join(' | ')));
    (b.setup||[]).slice(0,8).forEach((x,i)=>lines.push('Setup '+(i+1)+': '+(x.title||'')+' — '+(x.detail||'')));
    if(b.next)lines.push('Start here: '+b.next);
    return lines.join('\n').slice(0,12000);
  }
  return '';
}
function historyForAPI(chat){
  return (chat.messages||[]).slice(-10,-1).map(m=>{
    if(m.role==='user')return {role:'user',content:m.text||''};
    const text=(m.blocks||[]).map(blockHistoryText).filter(Boolean).join('\n\n');
    return {role:'assistant',content:text};
  }).filter(m=>m.content);
}
function connectedChannelNames(){return state.channels.filter(c=>c.on).map(c=>c.name);}
async function fetchAIResponse(chat,um,tok,attachments){
  const ctrl=new AbortController();tok.controller=ctrl;
  const r=await fetch('/api/arcline-sophie-chat',{
    method:'POST',headers:{'Content-Type':'application/json'},signal:ctrl.signal,
    body:JSON.stringify({message:um.text,mode:state.mode,platform:um.platform,goal:um.goal,brand:state.brand,activeChannels:connectedChannelNames(),history:historyForAPI(chat),attachments:Array.isArray(attachments)?attachments:[],playbook:store.get('arc.playbook',[]).slice(-10)})
  });
  let data={};try{data=await r.json();}catch(e){}
  if(!r.ok)throw new Error(data.error||'Arcline could not reach the strategist service.');
  return data;
}
function scrollAnswerToTop(el){
  requestAnimationFrame(()=>{
    const top=Math.max(0,el.offsetTop-66);
    stage.scrollTo({top,behavior:reduced?'auto':'smooth'});
  });
}

/* ---------- Generation ---------- */
function generationProfile(um){
  const raw=String(um&&um.text||''),display=String(um&&um.displayText||'').toLowerCase();
  const m=raw.match(/^AUTOPILOT_TASK:\s*([a-z0-9_]+)/i),task=m?m[1]:'';
  const profiles={
    meta_ads:{title:'Creating your Meta Ads launch pack',sub:['Reviewing your store and offer','Choosing what to advertise','Writing your ad ideas','Preparing simple launch steps']},
    tiktok_week:{title:'Building your TikTok content plan',sub:['Reviewing your products and audience','Choosing the strongest content angles','Writing hooks and video ideas','Preparing your posting plan']},
    lead_funnel:{title:'Building your lead funnel',sub:['Understanding your offer','Choosing the lead journey','Writing the capture and follow-up plan','Preparing the launch steps']},
    reels:{title:'Creating your Instagram Reels plan',sub:['Reviewing what is worth showing','Choosing Reel concepts','Writing hooks and scripts','Preparing the content schedule']},
    growth_90:{title:'Building your 90-day marketing plan',sub:['Reviewing the business','Choosing priorities','Building the 90-day roadmap','Preparing your first actions']},
    positioning:{title:'Improving your brand positioning',sub:['Reading your current message','Finding the clearest customer value','Building the positioning direction','Preparing the messaging plan']}
  };
  if(profiles[task])return profiles[task];
  if(display.includes('meta'))return profiles.meta_ads;
  if(display.includes('tiktok'))return profiles.tiktok_week;
  return {title:'Arcline is working on your plan',sub:['Reading your request','Thinking through the best approach','Building the recommendation','Doing a final check']};
}
function generationCard(um,tok){
  const p=generationProfile(um),el=document.createElement('div');
  el.className='gen-card';
  el.innerHTML='<div class="gen-card-top"><div class="gen-orb">'+MARK_SVG+'</div><div class="gen-copy"><div class="gen-title">'+esc(p.title)+'<span class="gen-dots"><i></i><i></i><i></i></span></div><div class="gen-sub">'+esc(p.sub[0])+'</div></div></div><div class="gen-track"><span></span></div><div class="gen-card-foot"><span>Arcline is actively creating this. You can stop at any time.</span><button class="gen-stop" type="button">Stop</button></div>';
  const sub=el.querySelector('.gen-sub');
  let i=0;
  const timer=setInterval(()=>{if(tok.stopped||!el.isConnected)return;sub.textContent=p.sub[Math.min(++i,p.sub.length-1)];},1200);
  el._genTimer=timer;
  el.querySelector('.gen-stop').onclick=()=>stopGen();
  return el;
}
function removeGenerationCard(el){
  if(!el)return;
  if(el._genTimer)clearInterval(el._genTimer);
  el.remove();
}
async function streamText(el,src,tok){
  const parts=src.match(/\S+\s*/g)||[];let acc='';
  for(let i=0;i<parts.length;i++){
    if(tok.stopped)break;
    acc+=parts[i];
    if(i%2===1||i===parts.length-1){
      el.innerHTML=md(acc+CARET).replace(CARET,'<span class="caret"></span>');
      await sleep(reduced?0:(14+Math.random()*24));
    }
  }
  el.innerHTML=md(acc);
  return acc.trim();
}
async function runAI(chat,um,attachments){
  const idx=chat.messages.length;
  const msg={role:'ai',kind:'strategy',steps:[],blocks:[],followups:[],mode:state.mode,ts:Date.now()};
  const el=aiShell(msg,idx);thread.appendChild(el);scrollAnswerToTop(el);
  const tok={stopped:false,controller:null};state.abort=tok;state.generating=true;setSendState();
  const content=el.querySelector('.ai-content');
  const genCard=generationCard(um,tok);content.appendChild(genCard);

  const trace=el.querySelector('.trace');
  trace.classList.add('open','live');
  trace.innerHTML='<button class="trace-sum" aria-expanded="true"><span class="spin"></span><span class="trace-label shimmer">Reading your brief</span></button><div class="trace-steps"><div class="ts-in"></div></div>';
  const tsIn=trace.querySelector('.ts-in'),label=trace.querySelector('.trace-label');
  const liveSteps=['Reading brand context','Finding the commercial constraint','Building the recommendation'];
  let liveIndex=0;
  const liveTimer=setInterval(()=>{if(tok.stopped)return;label.textContent=liveSteps[Math.min(++liveIndex,liveSteps.length-1)];},900);

  let res;
  try{
    res=await fetchAIResponse(chat,um,tok,attachments);
  }catch(err){
    clearInterval(liveTimer);
    if(tok.stopped||err.name==='AbortError')res={kind:'strategy',steps:['Stopped'],blocks:[{type:'text',md:'*Stopped before Arcline finished the response.*'}],followups:[]};
    else res={kind:'strategy',steps:['Connection check'],blocks:[{type:'text',md:'### Arcline could not complete that request\n'+(err.message||'The strategist service is unavailable right now.')+'\n\nYour workspace and question are still saved. Try again once the AI connection is healthy.'}],followups:[]};
  }
  clearInterval(liveTimer);

  msg.kind=res.kind||'strategy';msg.steps=res.steps||[];msg.followups=res.followups||[];msg.sources=res.sources||[];msg.brain=res.brain||null;
  tsIn.innerHTML='';
  for(const step of msg.steps){const st=document.createElement('div');st.className='tstep';st.innerHTML=ic('check',13)+'<span>'+esc(step)+'</span>';tsIn.appendChild(st);}
  const sum=trace.querySelector('.trace-sum');
  const doneLabel=tok.stopped?'Stopped':('Built in '+msg.steps.length+(msg.steps.length===1?' step':' steps'));
  sum.innerHTML=ic(tok.stopped?'x':'check',14)+'<span class="trace-label">'+doneLabel+'</span><span class="chev">'+ic('chevron-down',14)+'</span>';
  sum.setAttribute('aria-expanded','false');trace.classList.remove('open','live');

  removeGenerationCard(genCard);
  for(const b of (res.blocks||[])){
    if(tok.stopped)break;
    if(b.type==='text'){
      const d=document.createElement('div');d.className='md';content.appendChild(d);
      const out=await streamText(d,b.md,tok);if(out)msg.blocks.push({type:'text',md:out});
    }else{
      await sleep(reduced?0:120);if(tok.stopped)break;
      const node=renderBlock(b);node.classList.add('reveal');content.appendChild(node);msg.blocks.push(b);
      await sleep(reduced?0:260);
    }
  }
  if(!msg.blocks.length){msg.blocks.push({type:'text',md:'*Stopped before drafting a response.*'});const d=document.createElement('div');d.className='md';d.innerHTML=md(msg.blocks[0].md);content.appendChild(d);}
  if(tok.stopped){msg.followups=null;msg.stopped=true;}
  chat.messages.push(msg);
  if(state.current===chat.id&&el.isConnected)el.querySelector('.ai-foot').innerHTML=footHTML(msg,true);
  if(state.abort===tok)state.abort=null;state.generating=false;setSendState();save();renderHistory();
}
function stopGen(){
  if(state.abort){
    state.abort.stopped=true;
    const live=thread.querySelector('.gen-card .gen-title');
    if(live)live.textContent='Stopping…';
    const sub=thread.querySelector('.gen-card .gen-sub');
    if(sub)sub.textContent='Cancelling the current generation';
    if(state.abort.controller)state.abort.controller.abort();
  }
}

function send(override,opts){
  const text=(override!=null?override:input.value).trim();
  if(!text||state.generating)return;
  opts=opts||{};
  const displayText=String(opts.displayText||text).trim();
  closeSlash();closePop();
  let chat=currentChat();
  if(!chat){chat={id:uid(),title:titleFrom(displayText),platform:'all',created:Date.now(),messages:[]};state.chats.unshift(chat);state.current=chat.id;}
  const apiAttachments=state.attachments.map(f=>({name:f.name,type:f.type||'',data:f.data||'',text:f.text||''}));
  const um={role:'user',text,displayText,platform:state.platform,goal:state.goal,files:state.attachments.map(f=>f.name),autopilot:Boolean(opts.autopilot),task:opts.task||''};
  if(!chat.messages.length)chat.platform=state.platform!=='all'?state.platform:(detectPlatform(text.toLowerCase())||'all');
  chat.messages.push(um);
  input.value='';autogrow();state.attachments=[];renderAttachments();
  $$('.followups',thread).forEach(f=>f.remove());
  const wasEmpty=app.classList.contains('is-empty');
  setEmpty(false);
  if(wasEmpty)fineFocus();
  thread.appendChild(renderUser(um));
  renderHistory();save();
  runAI(chat,um,apiAttachments);
}
function setEmpty(on){
  app.classList.toggle('is-empty',on);
  const target=on?heroSlot:dockSlot;
  if(composer.parentElement!==target){const hadFocus=document.activeElement===input;target.appendChild(composer);if(hadFocus)input.focus();}
  jump.classList.remove('show');
}
function newChat(){
  if(state.generating)stopGen();
  state.current=null;thread.innerHTML='';setEmpty(true);renderHistory();
  stage.scrollTop=0;closeMobile();fineFocus();
}
function openChat(id){
  if(state.generating)stopGen();
  const c=state.chats.find(x=>x.id===id);if(!c)return;
  state.current=id;thread.innerHTML='';
  c.messages.forEach((m,i)=>thread.appendChild(m.role==='user'?renderUser(m):renderAIStatic(m,i,i===c.messages.length-1)));
  setEmpty(false);renderHistory();closeMobile();
  requestAnimationFrame(()=>{stage.scrollTop=stage.scrollHeight;});
}
function deleteChat(id){
  const i=state.chats.findIndex(c=>c.id===id);if(i<0)return;
  if(state.current===id)newChat();
  state.chats.splice(i,1);save();renderHistory();toast('Conversation deleted');
}
function closeMobile(){app.classList.remove('sb-open');}

/* ---------- Composer controls ---------- */
function autogrow(){input.style.height='auto';input.style.height=Math.min(input.scrollHeight,220)+'px';}
let sendKey='';
function setSendState(){
  const has=input.value.trim().length>0;
  const key=state.generating?'stop':(has?'ready':'idle');
  if(key===sendKey)return;sendKey=key;
  if(state.generating){sendBtn.disabled=false;sendBtn.className='send stop';sendBtn.innerHTML=ic('stop',16);sendBtn.setAttribute('aria-label','Stop generating');}
  else{sendBtn.disabled=!has;sendBtn.className='send'+(has?' ready':'');sendBtn.innerHTML=ic('arrow-up',18);sendBtn.setAttribute('aria-label','Send message');}
}
function setPlatform(id){
  const prev=state.platform;state.platform=id;const P=plat(id);
  $('#platformMono').innerHTML=monoChip(id);$('#platformName').textContent=P.name;
  renderFocus();
  const h=$('#heroTitle');
  if(prev!==id||!h.textContent){h.textContent=HEADLINES[id]||HEADLINES.all;h.classList.remove('swap');void h.offsetWidth;h.classList.add('swap');}
}
function setGoal(id){state.goal=id;const G=goalOf(id);$('#goalIc').innerHTML=ic(G.icon,15);$('#goalName').textContent=G.name;}
function setMode(id){state.mode=id;store.set('arc.mode',id);const M=modeOf(id);$('#modeSub').textContent=M.name;input.placeholder=M.ph;}

function renderAttachments(){
  $('#attachRow').innerHTML=state.attachments.map((f,i)=>'<span class="file"><span class="f-ic">'+ic('file',13)+'</span><span>'+esc(f.name)+'</span><button data-rm="'+i+'" aria-label="Remove '+esc(f.name)+'">'+ic('x',12)+'</button></span>').join('');
}

/* Slash commands */
let slashItems=[],slashIdx=0;
function updateSlash(){
  const v=input.value;
  if(v.startsWith('/')&&!/\s/.test(v)){
    const q=v.slice(1).toLowerCase();
    slashItems=COMMANDS.filter(c=>c.cmd.slice(1).includes(q)||c.label.toLowerCase().includes(q));
    if(slashItems.length){slashIdx=Math.min(slashIdx,slashItems.length-1);renderSlash();slash.classList.add('open');return;}
  }
  closeSlash();
}
function renderSlash(){
  slash.innerHTML='<div class="pop-h">Marketing commands</div>'+slashItems.map((c,i)=>'<button class="sl-it'+(i===slashIdx?' on':'')+'" role="option" aria-selected="'+(i===slashIdx)+'" data-si="'+i+'"><span class="p-ic">'+ic(c.icon,15)+'</span><span class="sl-cmd">'+c.cmd+'</span><span class="sl-lab">'+esc(c.label)+'</span><span class="sl-hint">'+esc(c.hint)+'</span></button>').join('');
}
function closeSlash(){slash.classList.remove('open');slashIdx=0;}
function pickSlash(i){const c=slashItems[i];if(!c)return;loadGuidedBrief(c.brief,state.platform,state.goal);}

/* Popovers */
let popAnchor=null;
function popItems(items,current,head){
  return (head?'<div class="pop-h">'+head+'</div>':'')+'<div class="pop-list">'+items.map(it=>'<button class="pop-it'+(it.id===current?' on':'')+'" role="menuitemradio" aria-checked="'+(it.id===current)+'" data-v="'+it.id+'">'+(it.lead||'')+'<span class="pop-txt"><b>'+esc(it.name)+'</b>'+(it.desc?'<small>'+esc(it.desc)+'</small>':'')+'</span>'+(it.id===current?ic('check',15):'')+'</button>').join('')+'</div>';
}
function openPop(anchor,html,cls,onPick){
  if(popAnchor===anchor){closePop();return;}
  closePop();
  pop.className='pop'+(cls?' '+cls:'');pop.innerHTML=html;
  const r=anchor.getBoundingClientRect(),pw=pop.offsetWidth,ph=pop.offsetHeight;
  const left=Math.min(Math.max(8,r.left),innerWidth-pw-8);
  let top=r.bottom+8;
  if(top+ph>innerHeight-8)top=Math.max(8,r.top-ph-8);
  pop.style.left=left+'px';pop.style.top=top+'px';
  pop.classList.add('open');popAnchor=anchor;anchor.setAttribute('aria-expanded','true');
  pop.onclick=e=>{const it=e.target.closest('[data-v]');if(!it)return;onPick(it.dataset.v);closePop();};
}
function closePop(){pop.classList.remove('open');if(popAnchor)popAnchor.setAttribute('aria-expanded','false');popAnchor=null;}
document.addEventListener('mousedown',e=>{if(popAnchor&&!pop.contains(e.target)&&!popAnchor.contains(e.target))closePop();});
window.addEventListener('resize',closePop);

$('#modeBtn').addEventListener('click',e=>openPop(e.currentTarget,popItems(MODES.map(m=>Object.assign({lead:'<span class="p-ic">'+ic(m.icon,16)+'</span>'},m)),state.mode,'Choose how Arcline works'),'',v=>{setMode(v);toast(modeOf(v).name+' mode on');}));
$('#platformBtn').addEventListener('click',e=>openPop(e.currentTarget,popItems(PLATFORMS.map(p=>Object.assign({lead:monoChip(p.id)},p)),state.platform,'Channel focus'),'grid2',v=>setPlatform(v)));
$('#goalBtn').addEventListener('click',e=>openPop(e.currentTarget,popItems(GOALS.map(g=>Object.assign({lead:'<span class="p-ic">'+ic(g.icon,15)+'</span>'},g)),state.goal,'Campaign goal'),'',v=>setGoal(v)));

/* ---------- Context panel ---------- */
function renderContext(){
  $$('.ctx-body input[data-k]').forEach(inp=>{const k=inp.dataset.k;inp.value=k==='budget'?(String(state.brand.budget||'').trim()?parseBudget(state.brand.budget).toLocaleString('en-US'):''):(state.brand[k]||'');});
  $('#voiceSeg').innerHTML=VOICES.map(v=>'<button class="'+(state.brand.voice===v?'on':'')+'" data-voice="'+v+'" aria-pressed="'+(state.brand.voice===v)+'">'+v+'</button>').join('');
  $('#chList').innerHTML=state.channels.map((c,i)=>'<div class="ch">'+chipRaw(c.mono,c.c)+'<span>'+esc(c.name)+'</span><span class="ch-s">'+(c.on?'Active':'Inactive')+'</span><button class="tgl" role="switch" aria-checked="'+c.on+'" aria-label="'+esc(c.name)+'" data-ch="'+i+'"></button></div>').join('');
  updateStrength();
}
function updateStrength(){
  const required=['name','offer','audience','market','budget'];
  const useful=['url'];
  const filled=required.filter(k=>{const el=$('.ctx-body input[data-k="'+k+'"]');return el&&el.value.trim()&&!(k==='name'&&el.value.trim()==='My Brand');}).length;
  const usefulFilled=useful.filter(k=>{const el=$('.ctx-body input[data-k="'+k+'"]');return el&&el.value.trim();}).length;
  const on=state.channels.filter(c=>c.on).length;
  const score=Math.min(100,18+filled*13+usefulFilled*7+on*2);
  const ring=$('#strRing');ring.style.setProperty('--p',score);$('#strNum').textContent=score;
  const missing=required.filter(k=>{const el=$('.ctx-body input[data-k="'+k+'"]');return !el||!el.value.trim()||(k==='name'&&el.value.trim()==='My Brand');});
  const labels={name:'brand name',offer:'offer',audience:'target audience',market:'primary market',budget:'budget'};
  $('#strTip').innerHTML='<b>Context strength</b>'+(missing.length?'Add '+esc(missing.slice(0,2).map(k=>labels[k]).join(' and '))+' so guided briefs can prefill the essentials.':'Strong core context. Guided briefs will reuse it automatically.');
}
function toggleCtx(force){
  const open=typeof force==='boolean'?force:!app.classList.contains('ctx-open');
  app.classList.toggle('ctx-open',open);
  if(open){renderContext();if(mqMobile.matches)app.classList.remove('sb-open');}
}
$('#ctxBtn').onclick=()=>toggleCtx();
$('#ctxClose').onclick=()=>toggleCtx(false);
$('#brandChip').onclick=()=>toggleCtx(true);
$('#wsBtn').onclick=()=>toggleCtx(true);
$('#sync').onclick=()=>toggleCtx(true);
$('.ctx-body').addEventListener('input',updateStrength);
$('#voiceSeg').addEventListener('click',e=>{const b=e.target.closest('[data-voice]');if(!b)return;state.brand.voice=b.dataset.voice;$$('#voiceSeg button').forEach(x=>{const on=x===b;x.classList.toggle('on',on);x.setAttribute('aria-pressed',on);});});
$('#chList').addEventListener('click',e=>{const b=e.target.closest('[data-ch]');if(!b)return;const c=state.channels[+b.dataset.ch];c.on=!c.on;b.setAttribute('aria-checked',c.on);b.parentElement.querySelector('.ch-s').textContent=c.on?'Active':'Inactive';updateStrength();});
$('#saveCtx').onclick=()=>{
  $$('.ctx-body input[data-k]').forEach(inp=>{const k=inp.dataset.k;state.brand[k]=k==='budget'?String(parseBudget(inp.value)):inp.value.trim();});
  store.set('arc.brand',state.brand);store.set('arc.channels',state.channels);
  renderBrandBits();toast('Brand context saved');
  if(mqNarrow.matches)toggleCtx(false);
};

/* ---------- Events ---------- */
$('#autoClose').onclick=closeAuto;
$('#autoCancel').onclick=()=>{if(autoController||!$('#autoProgress').hidden)stopAutoAnalysis();else closeAuto();};
$('#autoBuild').onclick=runAuto;
$('#autoUseSaved').onclick=useSavedWebsite;
$('#autoModal').addEventListener('mousedown',e=>{if(e.target===$('#autoModal')&&!autoController)closeAuto();});
$('#autoUrl').addEventListener('input',()=>{$('#autoStopped').hidden=true;$('#autoError').hidden=true;});
$('#autoUrl').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();runAuto();}});
$('#briefClose').onclick=closeBriefModal;
$('#briefCancel').onclick=()=>{if(briefStep===2)setBriefStep(1);else closeBriefModal();};
$('#briefEditBasics').onclick=()=>setBriefStep(1);
$('#briefModal').addEventListener('mousedown',e=>{if(e.target===$('#briefModal'))closeBriefModal();});
$('#briefForm').addEventListener('submit',e=>e.preventDefault());
$('#briefFields').addEventListener('input',e=>{
  const el=e.target;
  if(el&&el.tagName==='TEXTAREA'){
    autoSizeBriefTextarea(el);
    const field=el.closest('.brief-field');
    if(field){field.classList.remove('ai-filled');field.classList.add('user-edited');}
  }
});
$('#briefGenerate').onclick=()=>{
  if(!activeBrief||state.generating)return;
  if(briefStep===1){analyzeWebsiteAndContinue();return;}
  const form=$('#briefForm');
  const required=activeBrief.def.fields.filter(f=>f.r).map(f=>form.elements[f.k]).filter(Boolean);
  const bad=required.find(el=>!String(el.value||'').trim());
  if(bad){bad.focus();toast('Complete the highlighted campaign detail');return;}
  const prompt=compileBrief(form),label=activeBrief.def.display;
  closeBriefModal();send(prompt,{displayText:label});
};
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&$('#briefModal').classList.contains('open')){e.preventDefault();closeBriefModal();}});
input.addEventListener('input',()=>{autogrow();setSendState();updateSlash();});
input.addEventListener('keydown',e=>{
  if(slash.classList.contains('open')&&slashItems.length){
    if(e.key==='ArrowDown'){e.preventDefault();slashIdx=(slashIdx+1)%slashItems.length;renderSlash();return;}
    if(e.key==='ArrowUp'){e.preventDefault();slashIdx=(slashIdx-1+slashItems.length)%slashItems.length;renderSlash();return;}
    if(e.key==='Enter'||e.key==='Tab'){e.preventDefault();pickSlash(slashIdx);return;}
    if(e.key==='Escape'){e.preventDefault();closeSlash();return;}
  }
  if(e.key==='Enter'&&!e.shiftKey&&!e.isComposing){e.preventDefault();send();}
});
input.addEventListener('blur',()=>setTimeout(closeSlash,120));
slash.addEventListener('mousedown',e=>{const it=e.target.closest('[data-si]');if(it){e.preventDefault();pickSlash(+it.dataset.si);}});
sendBtn.addEventListener('click',()=>{if(state.generating)stopGen();else send();});

$('#attachBtn').onclick=()=>$('#fileInput').click();
const IMG_TYPES=['image/jpeg','image/png','image/webp','image/gif'];
const TEXT_EXT=/\.(txt|md|csv|json|html|css|js|ts|jsx|tsx)$/i;
function readDataURL(f){return new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(String(r.result||''));r.onerror=reject;r.readAsDataURL(f);});}
$('#fileInput').addEventListener('change',async e=>{
  const incoming=Array.from(e.target.files||[]);
  e.target.value='';
  let total=state.attachments.reduce((n,f)=>n+(f.size||0),0);
  for(const f of incoming){
    if(state.attachments.length>=4){toast('You can attach up to 4 files at a time');break;}
    if(total+f.size>2500000){toast('Attachments must stay under 2.5 MB total');break;}
    const isImage=IMG_TYPES.includes(f.type);
    const isText=(f.type&&f.type.startsWith('text/'))||TEXT_EXT.test(f.name);
    if(!isImage&&!isText){toast('Use an image or text-based file');continue;}
    const item={name:f.name,type:f.type||'',size:f.size};
    try{
      if(isImage)item.data=await readDataURL(f);
      else item.text=(await f.text()).slice(0,250000);
      state.attachments.push(item);total+=f.size;
    }catch(err){toast('Could not read '+f.name);}
  }
  renderAttachments();
});
$('#attachRow').addEventListener('click',e=>{const b=e.target.closest('[data-rm]');if(!b)return;state.attachments.splice(+b.dataset.rm,1);renderAttachments();});

let rec=null;
$('#micBtn').addEventListener('click',()=>{
  const btn=$('#micBtn');
  const SR=window.SpeechRecognition||window.webkitSpeechRecognition;
  if(!SR){toast('Voice input isn\u2019t supported in this browser');return;}
  if(rec){rec.stop();return;}
  try{
    rec=new SR();rec.interimResults=true;rec.lang='en-US';
    const base=input.value;
    rec.onresult=ev=>{let t='';for(const r of ev.results)t+=r[0].transcript;input.value=(base?base+' ':'')+t;autogrow();setSendState();};
    rec.onend=()=>{rec=null;btn.classList.remove('rec');btn.setAttribute('aria-label','Voice input');};
    rec.onerror=()=>{toast('Microphone access is blocked here');};
    rec.start();btn.classList.add('rec');btn.setAttribute('aria-label','Stop voice input');
  }catch(err){rec=null;btn.classList.remove('rec');toast('Microphone access is blocked here');}
});

thread.addEventListener('click',e=>{
  const cp=e.target.closest('[data-copy]');if(cp){copyText(cp.dataset.copy);return;}
  const sum=e.target.closest('.trace-sum');
  if(sum){const tr=sum.parentElement;if(tr.classList.contains('live'))return;const o=tr.classList.toggle('open');sum.setAttribute('aria-expanded',o);return;}
  const fu=e.target.closest('[data-fu]');if(fu){send(fu.dataset.fu);return;}
  const act=e.target.closest('[data-act]');if(!act)return;
  const msgEl=act.closest('.msg'),a=act.dataset.act;
  if(a==='copy'){copyText(msgEl.querySelector('.ai-content').innerText);}
  else if(a==='up'||a==='down'){
    msgEl.querySelector('[data-act="'+(a==='up'?'down':'up')+'"]').classList.remove('on');
    act.classList.toggle('on');
    if(act.classList.contains('on')){
      const fb=store.get('arc.feedback',[]);fb.push({chatId:state.current,idx:+msgEl.dataset.idx,value:a,ts:Date.now()});store.set('arc.feedback',fb.slice(-100));
      toast(a==='up'?'Marked as helpful':'Marked as not helpful');
    }
  }
  else if(a==='save'){
    if(act.classList.contains('on'))return;
    const chat=currentChat(),idx=+msgEl.dataset.idx,m=chat&&chat.messages[idx];
    const text=m&&m.blocks?(m.blocks.filter(b=>b.type==='text').map(b=>b.md||'').join('\n\n')):'';
    const pb=store.get('arc.playbook',[]),id=(chat?chat.id:'chat')+':'+idx;
    if(!pb.some(x=>x.id===id))pb.push({id,chatTitle:chat?chat.title:'Conversation',savedAt:Date.now(),mode:m&&m.mode||state.mode,text:text.slice(0,12000)});
    store.set('arc.playbook',pb.slice(-50));
    act.classList.add('on');act.innerHTML=ic('check',14)+'<span>Saved to playbook</span>';toast('Saved to playbook');
  }
  else if(a==='regen'){
    if(state.generating)return;
    const chat=currentChat();if(!chat)return;
    if(thread.lastElementChild!==msgEl){toast('Only the latest response can be regenerated');return;}
    chat.messages.pop();const um=chat.messages[chat.messages.length-1];msgEl.remove();
    if(um&&um.role==='user')runAI(chat,um);
  }
});

histEl.addEventListener('click',e=>{const del=e.target.closest('[data-del]');if(del){e.stopPropagation();deleteChat(del.dataset.del);return;}const h=e.target.closest('.hist');if(h)openChat(h.dataset.id);});
histEl.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.classList.contains('hist'))openChat(e.target.dataset.id);});
searchInput.addEventListener('input',renderHistory);
$('#studios').addEventListener('click',e=>{
  const b=e.target.closest('[data-studio]');if(!b)return;
  const s=STUDIOS[+b.dataset.studio];newChat();loadGuidedBrief(s.brief,state.platform,state.goal);
});

sgEl.addEventListener('click',e=>{
  const c=e.target.closest('.sg');if(!c)return;
  loadGuidedBrief(c.dataset.brief,c.dataset.p,c.dataset.goal);
});
focusEl.addEventListener('click',e=>{const c=e.target.closest('[data-f]');if(c)setPlatform(c.dataset.f);});
$('#shuffle').onclick=()=>{sgOffset=(sgOffset+6)%SUGGEST.length;renderSuggest();};

$('#newChat').onclick=newChat;
$('#tbNew').onclick=newChat;
$('#homeLink').addEventListener('click',e=>{e.preventDefault();newChat();});
$('#sbToggle').onclick=()=>{if(mqMobile.matches)app.classList.toggle('sb-open');else app.classList.toggle('sb-collapsed');};
$('#sbClose').onclick=closeMobile;
$('#scrim').onclick=()=>{app.classList.remove('sb-open');app.classList.remove('ctx-open');};
async function refreshAIStatus(showToast){
  const s=$('#aiStatus');
  try{
    const r=await fetch('/api/arcline-sophie-health',{cache:'no-store'}),d=await r.json();
    const ok=Boolean(d&&d.configured&&d.brain&&d.brain.ready);
    if(s)s.textContent=ok?'ArcLine Brain ready':(d&&d.configured?'Brain check needed':'Setup needed');
    const meter=$('.meter i');if(meter)meter.style.width=ok?'100%':(d&&d.configured?'70%':'38%');
    if(showToast)toast(ok?('ArcLine Brain '+d.brain.version+' · '+d.brain.packs+' knowledge packs ready'):(d&&d.configured?'AI connected; knowledge layer needs attention':'DeepSeek API key is not configured'));
  }catch(err){if(s)s.textContent='Status unknown';if(showToast)toast('Could not check AI status');}
}
function exportWorkspace(){
  const data={version:1,exportedAt:new Date().toISOString(),brand:state.brand,activeChannels:state.channels,chats:state.chats||[],playbook:store.get('arc.playbook',[]),feedback:store.get('arc.feedback',[])};
  const blob=new Blob([JSON.stringify(data,null,2)],{type:'application/json'});
  const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='arcline-workspace-'+new Date().toISOString().slice(0,10)+'.json';document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);toast('Workspace exported');
}
function blockPlain(b){
  if(!b)return '';
  if(b.type==='text')return b.md||'';
  if(b.type==='ads')return (b.items||[]).map((x,i)=>(i+1)+'. '+(x.primary||'')+'\nHeadline: '+(x.headline||'')+'\nCTA: '+(x.cta||'')).join('\n\n');
  if(b.type==='hooks')return (b.items||[]).map((x,i)=>(i+1)+'. '+(x.text||'')).join('\n');
  if(b.type==='calendar')return (b.days||[]).map(x=>(x.d||'')+' '+(x.f||'')+': '+(x.t||'')).join('\n');
  return '';
}
function transcript(){
  const chat=currentChat();if(!chat)return '';
  const lines=['Arcline — '+chat.title,''];
  (chat.messages||[]).forEach(m=>{
    if(m.role==='user')lines.push('You: '+(m.text||''));
    else lines.push('Arcline: '+(m.blocks||[]).map(blockPlain).filter(Boolean).join('\n\n'));
    lines.push('');
  });
  return lines.join('\n').trim();
}
$('#planBtn').onclick=()=>refreshAIStatus(true);
$('#meBtn').onclick=exportWorkspace;
$('#shareBtn').onclick=async()=>{
  if(app.classList.contains('is-empty')){toast('Start a conversation to share it');return;}
  const chat=currentChat(),text=transcript();
  if(navigator.share){
    try{await navigator.share({title:'Arcline — '+(chat?chat.title:'Conversation'),text});return;}
    catch(err){if(err&&err.name==='AbortError')return;}
  }
  copyText(text);
};

stage.addEventListener('scroll',()=>{jump.classList.toggle('show',!app.classList.contains('is-empty')&&!nearBottom());},{passive:true});
jump.onclick=()=>stage.scrollTo({top:stage.scrollHeight,behavior:reduced?'auto':'smooth'});

document.addEventListener('keydown',e=>{
  if((e.metaKey||e.ctrlKey)&&e.key.toLowerCase()==='k'){e.preventDefault();newChat();}
  if(e.key==='Escape'){closePop();app.classList.remove('sb-open');if(mqNarrow.matches)app.classList.remove('ctx-open');}
});

/* Theme */
const root=document.documentElement;
const savedTheme=store.get('arc.theme',null);
if(savedTheme)root.dataset.theme=savedTheme;
function isDark(){return root.dataset.theme?root.dataset.theme==='dark':matchMedia('(prefers-color-scheme: dark)').matches;}
function paintTheme(){$('#themeBtn').innerHTML=ic(isDark()?'sun':'moon',17);}
$('#themeBtn').onclick=()=>{root.dataset.theme=isDark()?'light':'dark';store.set('arc.theme',root.dataset.theme);paintTheme();};

/* ---------- Init ---------- */
document.querySelectorAll('[data-ic]').forEach(el=>{
  const existing=Array.from(el.querySelectorAll(':scope > svg.ic'));
  existing.slice(1).forEach(svg=>svg.remove());
  if(!existing.length)el.insertAdjacentHTML('afterbegin',ic(el.dataset.ic,+el.dataset.s||16));
});
$$('.mark').forEach(m=>{if(!m.innerHTML)m.innerHTML=MARK_SVG;});
if(/Mac|iPhone|iPad/.test(navigator.platform||''))$('.new-chat kbd').textContent='\u2318K';
paintTheme();
renderBrandBits();
refreshAIStatus(false);
renderHistory();
renderSuggest();
setMode(state.mode);
setGoal('sales');
state.platform='all';
$('#platformMono').innerHTML=monoChip('all');
renderFocus();
setEmpty(true);
setSendState();
})();
